<template>
  <div
    class="ms-editor flex ms-right-click-menu"
    :class="{
      selectedTextMode: selectedTextMode,
      'h-auto': maxHeight,
      'flex-column': flex,
      'has-scroll-x': hasScrollX,
      'has-paging': pagination,
      'has-footer': footer,
    }"
    @contextmenu="openMenu"
  >
    <input class="input-invisiabled input-fake-first" @focus="focusFisrtControl" ref="inputTop" v-if="!disabled" />
    <div
      :class="['ms-content--table', stickeyCountClass, {'flex scroller': flex, 'has-footer': footer}, scrollSelector]"
      ref="content"
      @scroll="tableScroll"
      v-click-away="onClickAway"
    >
      <div class="grid-scroll">
        <table class="ms-table" cellpadding="0" cellspacing="0">
          <!-- This is Header -->
          <thead class="ms-thead" :class="{multi: headers.length > 1}" ref="thead">
            <tr v-for="(headerItem, i1) in headers" :key="i1" class="ms-tr" :class="`tr-${i1 + 1}`">
              <th v-if="dragRow" class="drag-row-header ms-th"></th>
              <th
                class="ms-th serial-title"
                v-if="serial && i1 === 0"
                :rowspan="headers.length"
                title="Số thứ tự"
                :style="{left: serialOffsetLeft}"
                :class="{sticky: hasLockColumn}"
              >
                STT
              </th>
              <th
                class="ms-th multiple-cell"
                :class="[{'multiple-cell-firefox': this.checkIsFirefox()}]"
                v-if="multiple && i1 === 0"
                :rowspan="headers.length"
              >
                <ms-checkbox
                  :disabled="disabled"
                  v-model="checkedAll"
                  @input="changeCheckedMultiple"
                  class="justify-center"
                  checkOnly
                />
              </th>

              <template v-for="(col, i2) in headerItem">
                <th
                  v-if="col.isGroup"
                  :key="i2"
                  :colspan="col.colspan"
                  :rowspan="col.rowspan"
                  :class="['ms-th-editor ms-th ms-col-th row-group', dbOptionHeight]"
                >
                  {{ col.caption }}
                </th>
                <ms-th-editor
                  v-else
                  ref="th"
                  class="ms-th ms-col-th"
                  :class="[{'ms-col-th-last': col.last}, col.classHeader, col.textAlign ? col.textAlign : '']"
                  :levelHeader="i1 + 1"
                  :key="col.dataField"
                  :col="col"
                  :isCheckedAll="checkedAll"
                  :resizeCol="
                    resizeCol &&
                    i2 <
                      (headerItem[headerItem.length - 1].dataField === 'rowAction'
                        ? headerItem.length - 2
                        : headerItem.length - 1)
                  "
                  :rowspan="col.rowspan ?? 0"
                  :filterable="filterable"
                  :colValue="colValue[col.dataField]"
                  @resizeOff="resizeClose"
                  @sort="sort"
                  @deleteClick="deleteAllRow"
                  @changeLock="columnChangeLock"
                  @resizeOn="handlerResizeOn"
                  @changeColumnResize="changeColumnResize"
                  @filter="filterHandler"
                  @loadFilter="
                    (payload, row, column) => {
                      loadColumnFilter(payload, row, column, col);
                    }
                  "
                  :propsData="propsData"
                  :filterMode="queryMode"
                  :dataComboFilter="dataComboFilter"
                />
              </template>

              <th
                v-if="widgetOptions && i1 === 0"
                :rowspan="headers.length"
                class="ms-th widget-title"
                :class="[`text-${widgetOptions.align ? widgetOptions.align : 'right'}`]"
                :style="[
                  {
                    width: `${widgetOptions.width}px`,
                    'min-width': `${widgetOptions.width}px`,
                  },
                ]"
              >
                <span>{{ widgetOptions.title }}</span>
              </th>

              <slot name="widget-title-th" :rowspan="0" v-if="$slots['widget-title-th'] && i1 === 0" />
              <th class="ms-th widget-title ms-th-col" v-else-if="$slots['widget-title'] && i1 === 0" :rowspan="0">
                <slot name="widget-title" />
              </th>
            </tr>
          </thead>

          <!-- <transition
          name="trans-content-table"
          mode="out-in"
          v-on:before-enter="beforeRenderContent"
        >-->

          <!-- This is Body -->
          <tbody v-if="loading">
            <tr v-for="n in shimmerRow" :key="n" :index="n">
              <td
                v-for="(sc, i) in shimmerColumn"
                :key="i"
                :class="{sticky: sc.lock}"
                :style="{
                  left: typeof sc.offset == 'number' ? sc.offset + 'px' : 'unset',
                }"
              >
                <div class="shimmer"></div>
              </td>
            </tr>
          </tbody>
          <draggable
            v-if="dataDragable && !loading"
            handle=".drag-data"
            :list="[]"
            :swapThreshold="0.1"
            tag="tbody"
            class="ms-tbody data"
            @change="dataDragChanged"
            :move="moveRow"
          >
            <ms-tr-editor
              v-for="(dataRow, indexRow) in dataView"
              :key="dataRow[idField]"
              :ref="`trEditor_${dataRow[idField]}`"
              :columns="columnx"
              :dataRow="dataRow"
              :rowIndex="indexRow"
              :isSelected="isSelected(dataRow)"
              :widgetOptions="widgetOptions"
              :multiple="multiple"
              :serial="serial"
              v-on="listeners"
              :editable="editable"
              :dataDragable="true"
              @click="rowClick(dataRow, indexRow)"
              @copyActionClick="copyActionClick"
              :isCopyDataColumn="isCopyDataColumn"
              :rowActions="rowActions"
              :isConfigReport="isConfigReport"
              :customReadOnly="customReadOnly"
              :customCellEditor="customCellEditor"
              :customValidateRules="customValidateRules"
              :disabled="disabled"
              :propsData="propsData"
              :lineBreak="lineBreak"
              :textarea="textarea"
              :class="[
                {'row-editor': dataRow == rowSelected},
                {
                  'row-selected': dataRow.selected,
                },
              ]"
              :allowEdit="allowEdit"
              :customControlType="customControlType"
              :dragRow="dragRow"
              :configVoucherQuickEdit="configVoucherQuickEdit"
              :isQuickEditVoucher="isQuickEditVoucher"
            >
              <template v-if="$slots['widget-body']" #widget>
                <slot name="widget-body" :record="dataRow" :index="indexRow" />
              </template>
            </ms-tr-editor>
          </draggable>
          <tbody class="ms-tbody data" v-else-if="!loading">
            <template v-if="groupField && groupField.length > 0">
              <template v-for="(group, indexRow) in groupData" :key="indexRow">
                <!-- key để phức tạp như vậy để tránh trùng với các đối tượng khác -->
                <ms-tr-group
                  v-if="!group?.isSummaryGr && group.isGroup"
                  class="ms-tr"
                  :columnSumary="columnSumary"
                  :dataRow="group"
                  @toogleTree="toggleTree"
                  :linkedGroupField="linkedGroupField"
                  @click="clickRowGroup($event, group, indexRow)"
                >
                  <template v-if="$slots['widget-body']" v-slot:widget>
                    <slot name="widget-body" :record="group" />
                  </template>
                </ms-tr-group>
                <!-- Dòng tổng theo group -->
                <ms-tr-sum-group
                  v-else-if="group.isSummaryGr"
                  class="ms-tr-sum-gr"
                  :columnSumary="columnSumary"
                  :dataRow="group"
                ></ms-tr-sum-group>
                <ms-tr-editor
                  v-else-if="!group.isHide"
                  :key="[indexRow, group[idField]].join('-')"
                  :ref="`trEditor_${group[idField]}`"
                  :columns="columnx"
                  :dataRow="group"
                  :rowIndex="group.indexRow"
                  :isCumtomSortOrderGroup="isCumtomSortOrderGroup"
                  :isConfigReport="isConfigReport"
                  :isSelected="isSelected(group)"
                  :widgetOptions="widgetOptions"
                  :multiple="multiple"
                  :serial="serial"
                  v-on="listeners"
                  :rowActions="rowActions"
                  :editable="editable"
                  :customReadOnly="customReadOnly"
                  :customCellEditor="customCellEditor"
                  :customValidateRules="customValidateRules"
                  :disabled="disabled"
                  :propsData="propsData"
                  :lineBreak="lineBreak"
                  :class="[
                    {'row-editor': group == rowSelected},
                    {
                      'row-selected': group.selected,
                    },
                  ]"
                  :hasLockColumn="hasLockColumn"
                  @eventShortkeyAction="eventShortkeyAction"
                  @copyActionClick="copyActionClick"
                  :isCopyDataColumn="isCopyDataColumn"
                  :allowEdit="allowEdit"
                  :customControlType="customControlType"
                  :configVoucherQuickEdit="configVoucherQuickEdit"
                  :isQuickEditVoucher="isQuickEditVoucher"
                  :textarea="textarea"
                >
                </ms-tr-editor>
              </template>
            </template>

            <template v-else>
              <ms-tr-editor
                v-for="(dataRow, indexRow) in dataView"
                :key="dataRow[idField]"
                :ref="`trEditor_${dataRow[idField]}`"
                :columns="columnx"
                :dataRow="dataRow"
                :rowIndex="indexRow"
                :isConfigReport="isConfigReport"
                :isSelected="isSelected(dataRow)"
                :widgetOptions="widgetOptions"
                :multiple="multiple"
                :serial="serial"
                v-on="listeners"
                :rowActions="rowActions"
                :editable="editable"
                :customReadOnly="customReadOnly"
                :customCellEditor="customCellEditor"
                :customValidateRules="customValidateRules"
                :disabled="disabled"
                :propsData="propsData"
                :lineBreak="lineBreak"
                :class="[
                  {'row-editor': dataRow == rowSelected},
                  {
                    'row-selected': dataRow.selected,
                  },
                ]"
                :hasLockColumn="hasLockColumn"
                @eventShortkeyAction="eventShortkeyAction"
                @copyActionClick="copyActionClick"
                :isCopyDataColumn="isCopyDataColumn"
                :allowEdit="allowEdit"
                :customControlType="customControlType"
                :configVoucherQuickEdit="configVoucherQuickEdit"
                :isQuickEditVoucher="isQuickEditVoucher"
                :textarea="textarea"
              >
              </ms-tr-editor>

              <!-- <tr class="empty-tr" v-if="!disabled">
              <td colspan="3" class="sticky" @click="emptyClick">
                <div class="empty-addnew">
                  {{ $t('i18nComponent.Grid.AddNew') }}
                </div>
              </td>
              <td colspan="50"></td>
            </tr> -->
            </template>
          </tbody>
          <!-- vvkiet - 20.09.2021: Thêm code để hiển thị icon grid-no-data -->
          <div v-if="isShowImageGridEmpty && !loading && styleEmptyData == 1" class="grid-no-data">
            <img src="@/assets/images/empty/bg_report_nodata.svg" class="img-bg" />
            <div class="empty-des">{{ $t('i18nCommon.noData') }}</div>
          </div>
          <div v-else-if="isShowImageGridEmpty && !loading && styleEmptyData == 2" class="grid-no-data">
            <img style="height: 75px" src="@/assets/images/empty/Empty_State_Search.svg" class="img-bg" />
            <div class="empty-des">{{ $t('i18nCommon.notFoundData') }}</div>
          </div>
          <!-- </transition> -->
        </table>

        <div
          class="table-footer"
          ref="tableFooter"
          v-if="footer && !loading"
          :class="[stickeyCountClass, {visibility: dataView.length == 0 && hideFooterEmpty == true}]"
        >
          <table cellspacing="0">
            <tfoot class="ms-footer data">
              <tr v-for="(footerItem, i1) in footers" :key="i1" class="ms-tr">
                <!-- <th class="ms-th multiple-cell sticky"
                  v-if="multiple && i1 === 0" :rowspan="footers.length"
                  style="left: 0">
                  <ms-checkbox
                    :value="isCheckedMultiple"
                    @click="changeCheckedMultiple"
                    class="justify-center"
                    checkOnly
                  />
            </th>-->
                <th v-if="dragRow" class="drag-row-footer"></th>

                <template v-for="(col, i2) in footerItem" :key="i2">
                  <th
                    v-if="col.isGroup"
                    :colspan="col.colspan"
                    :class="{sticky: typeof col.stickyOffset === 'number'}"
                    style="left: 0"
                  >
                    {{ col.caption }}
                  </th>

                  <th
                    v-else
                    :colspan="col.colspan"
                    :class="[
                      {sticky: typeof col.stickyOffset === 'number'},
                      col.dataField,
                      col?.isSummaryGr ? 'footer-sum-gr' : dbOptionHeight,
                    ]"
                    class="ms-th-viewer static-col"
                    :style="getFooterStyle(col)"
                  >
                    <div class="flex" :class="[`text-${col.align || 'left'}`, col.classes]">
                      <slot :name="'footer_' + col.dataField"></slot>
                      <div
                        v-if="typeof col.footerText == 'string'"
                        v-html="$ms.commonFn.processXssValue(col.footerText)"
                      ></div>
                      <div
                        v-else-if="summaryData"
                        :class="[`text-${col.align || 'left'}`]"
                        v-html="getSummaryDisplay(col, i1, i2)"
                      ></div>
                      <div
                        v-else
                        :class="[`text-${col.align || 'left'}`]"
                        v-html="getSummaryDisplay(col, i1, i2)"
                      ></div>
                    </div>
                  </th>
                </template>

                <th
                  class="ms-th widget-title"
                  v-if="widgetOptions && i1 === 0"
                  :rowspan="footers.length"
                  :class="[`text-${widgetOptions.align ? widgetOptions.align : 'right'}`]"
                  :style="[
                    {'min-width': `${widgetOptions.width}px`},
                    columnx.length > 0 ? {width: `${widgetOptions.width}px`} : null,
                  ]"
                ></th>
              </tr>
            </tfoot>
          </table>
        </div>

        <ms-pagination
          class="table-paging"
          v-if="pagination"
          :pageSize="pageSize"
          :dataRender="datax.length"
          :pageIndex="currentPage"
          ref="pagination"
          :summary="summary"
          :pageTotal="pageTotalPaging"
          :rowTotal="dataViewAllPagin?.length || pageTotalPaging"
          :isShowPageSizeCombox="isShowPageSizeCombox"
          :isOnlyShowPageTotal="isOnlyShowPageTotal || (isGridInViewDetail && pageTotal <= 10)"
          :pageTotalCaption="pageTotalCaptionData"
          @loadData="listenersLoadData"
          @changePageSize="changePageSize"
          @customPreOrNextPage="customPreOrNextPage"
          :isCustomPreOrNextPage="isCustomPreOrNextPage"
          :loading="loadingSummary && loading"
          :isGridSummaryGroup="isSummaryGroup"
        ></ms-pagination>
      </div>
    </div>

    <input class="input-invisiabled" @focus="focusLastControl" ref="inputBottom" v-if="!disabled" />
    <div v-if="disabled" class="disabled"></div>

    <ul
      :class="dbOptionHeightWrapper"
      class="menu-wrapper-menu menu-wrapper-right-click"
      id="right-click-menu"
      ref="rightClick"
      :tabindex="-1"
      v-if="viewMenu"
      @blur="closeMenu"
      :style="[{top: top}, {left: left}]"
    >
      <li
        :class="dbOptionHeightWrapperLi"
        class="menu-wrapper-item"
        v-for="(item, index) in itemRightClicks"
        :key="index"
        @click="handleActionRightClick(item)"
      >
        {{ item.text }}
      </li>
    </ul>
  </div>
</template>
<script>
import msTrEditor from './MsTrEditor.vue';
import msTrGroup from '../gridViewer/MsTrGroup.vue';
import msTrSumGroup from '../gridViewer/MsTrSumGroup.vue';
import msThEditor from './MsThEditor.vue';
import msPagination from './MsPagination.vue';
import commonFn from '@/commons/commonFunction.js';
import msBaseComponent from '@/components/base/MsBaseComponent.vue';
import {VueDraggableNext} from 'vue-draggable-next';
import {gridGroupData} from '@/mixins/component/gridGroupData';
import summaryUtil from '@/commons/summaryUtil';
import {defineComponent, getCurrentInstance, nextTick, provide, shallowRef, reactive, computed, ref} from 'vue';
import {useColumnResize} from '@/setup/grid/resizeColumn.js';
import {filter} from '@/mixins/common/filter.js';
import {showConfirm} from '@/commons/globalMessage';
import {skipDataField} from '@/mixins/component/skipDataField.js';
import i18nValidate from '@/i18ns/vi/i18nValidate';
import popupUtil from '@/commons/popupUtil';
import {useCopyFromExcel} from './cellEditor/CopyFromExcel.js';
import componentUtil from '@/commons/componentUtil';
import { collectionMonitor } from '@/setup/utilities/monitor';

import _ from 'lodash';
export default defineComponent({
  name: 'msGridEditor',
  extends: msBaseComponent,
  mixins: [gridGroupData, filter, skipDataField],
  components: {
    msTrEditor,
    msThEditor,
    msPagination,
    draggable: VueDraggableNext,
    msTrGroup,
    msTrSumGroup,
  },
  props: {
    /**
    Text tìm kiếm
     */
    searchText: {
      type: String,
      default: () => '',
    },
    /**
     * Thêm formID để xử lý dispose trường hợp control combo có quickAddMulti
     * NXCHIE 18.08.2022
     */
    formId: {
      type: String,
      default: '',
    },

    //Value thực hiện lưu giá trị các cột được chọn
    modelValue: {
      type: [Array, Object],
      default() {
        return [];
      },
    },
    hasEditor: {
      type: [Function],
      default() {
        return null;
      },
    },
    /**
     * Tên thuộc tính trong current item dùng để binding
     */
    detailField: {
      type: String,
    },
    /**
     * có show text filter khi lọc ra không
     */
    hasBindingFilterHeader: {
      default: false,
      type: Boolean,
    },

    /**
     * TVLoi(12/05/2021)
     * Disable control
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Loại bỏ những dòng có state là Empty khi ở trạng thái disabled hay không
     */
    preventEmptyDisabled: {
      type: Boolean,
      default: true,
    },

    /**
     * Tổng tiền
     */
    totalAmount: {
      type: Number,
      default: 0,
    },

    //Data dữ liệu grid từ ngoài truyền vào
    data: {
      type: Array,
      return: () => [],
    },
    //Cấu hình các cột truyền vào
    /**
		 * Các thuộc tính trong columns
		 * @params dataField Field dữ liệu dùng để nhận giá trị thay đổi và hiện thị.
		 * @params title:Tiêu đề của cột
		 * @params width:độ rộng của cột
		 * @params autoResize:Cột tự động to ra khi màn hình lớn
		 * @params formatType:Dữ liệu dùng để format lấy từ trong file enumeration.js FormatType
		 * @params columnType bao gồm các loại combobox,input,number,checkbox,datepicker,dropdown,template mặc định là input dùng để định nghĩa loại control editor
		 * @params editorProperty thông tin chuyền vào control editor thường có cấu trúc :
		 * editorProperty: {
							propsData: {
								(Dữ liệu truyền vào control)
							}
						}
			@params rules:"Trường dùng để validate trong grid các rule được phân cách nhau bởi ký hiệu | VD: required|email"
			@params template:Sử dụng 1 file khác ở ngoài truyền vào để render
		 */
    columns: {},
    /**
     * Cấu hình cho cột chức năng là 1 đối tượng gồm có
     * title: tên tiêu đề cột chức năng
     * components:'components import vào'
     * width:Độ rộng của cột
     */
    widgetOptions: {},
    //Set độ rộng cho grid
    maxHeight: {
      default: 'none',
      type: [Number, String],
    },
    //Cấu hình có phân trang hay không
    pagination: {
      default: false,
      type: Boolean,
    },
    //Cấu hình có custom lại hàm next/pre trang không
    isCustomPreOrNextPage: {
      default: false,
      type: Boolean,
    },
    //Nhận 2 giá trị remote/local để lấy giá trị ở server hoặc local(hiện tại gridEditor chỉ hỗ trọ local)
    queryMode: {
      default: 'local',
      type: String,
    },
    deleteAllRowCustom: {
      type: Boolean,
      default: false,
    },
    //Số bản ghi trên mới trang trường hợp phân trang local
    pageSize: {
      default: 20,
      type: Number,
    },
    //Cột cho phép tích chọn nhiều dòng
    multiple: {
      default: false,
      type: Boolean,
    },
    //Store xử lý dữ liệu trên liên quan đến data trong grid
    store: {
      default: null,
    },
    serial: {
      default: false,
      type: Boolean,
    },
    useVirtualScroll: {
      default: false,
      type: Boolean,
    },
    //Thuộc tính để cấu hình cho phép sửa trên grid hay không
    editable: {
      default: true,
      type: Boolean,
    },
    //Dữ liệu default
    defaultData: {
      default: null,
    },
    flex: {
      default: true,
      type: Boolean,
    },
    /**
     * Cho phép sắp xếp lại dữ liệu
     */
    dataDragable: {
      default: false,
      type: Boolean,
    },
    /**
     * Action của row
     */
    rowActions: {
      default: () => [],
      type: [Object, Array],
    },
    /**
     * Cho phép resize col hay k
     */
    resizeCol: {
      default: true,
      type: Boolean,
    },
    // function Custom ReadOnly
    customReadOnly: {
      type: Function,
      default: null,
    },
    /**
     * NNLAM 22/03/2021
     * prop kiểu hàm custom validate trên cell grid
     */
    customValidateRules: {
      type: [Function, Boolean],
      default: null,
    },
    //Có footer hay không ?
    footer: {
      default: false,
      type: Boolean,
    },
    /**
     * @author vvkiet - 31.03.2021
     * Thêm tag để xử lý scroll trong grid
     */
    scrollSelector: {
      type: String,
      default: null,
    },

    /**
     * nmtuan4 25.7.2022
     * grid thêm dòng khi add đến cuỗi không
     */
    hasAddRow: {
      type: Boolean,
      default: true,
    },

    /**
     * NMSINH: 30/08/2021
     * grid có dòng tổng không
     */
    hasSumTotal: {
      type: Boolean,
      default: false,
    },

    isShowPageSizeCombox: {
      default: true,
      type: Boolean,
    },
    isGridInViewDetail: {
      type: Boolean,
      default: false,
    },
    isOnlyShowPageTotal: {
      type: Boolean,
      default: false,
    },

    //module để thực hiện autocomplete khi lọc trên th
    moduleAutocomplete: {
      type: String,
      default: null,
    },
    loadingSummary: {
      default: false,
    },
    /**
     * Số dòng shimmer loading
     */
    shimmerRow: {
      type: Number,
      default: 3,
    },
    summary: {},
    /**
     * Dữ liệu tổng
     * Dùng cho sum lấy từ server truyền vào (không phụ thuộc vào trang đang hiển thị)
     */
    summaryData: {
      type: Object,
      default: null,
    },
    //Tổng số bản ghi
    pageTotal: {
      default: 0,
      type: Number,
    },
    /**
     * có filter cột không
     */
    filterable: {
      type: Boolean,
      default: false,
    },
    /**
     * tự orverite hàm end editor, không autoend theo base
     */
    overiteEndEditor: {
      type: Boolean,
      default: false,
    },
    initDataBeforeAddRow: {
      type: [Function, Object],
      default: null,
    },
    beforeAddRow: {
      type: [Function, Object],
      default: null,
    },
    /**
     * Có muốn hiển thị icon trống hay không
     */
    isShowImageGridEmpty: {
      default: null,
      type: Boolean,
    },

    /**
     * Nội dung màn trống khi không có dữ liệu
     */
    customTextNodata: {
      default: null,
      type: String,
    },

    /**
     * Nội dung màn trống khi lọc dữ liệu không được bản ghi nào
     */
    customTextNoRecord: {
      default: null,
      type: String,
    },
    propsData: {
      default: {},
      type: Object,
    },
    idField: {
      default: 'id',
      type: String,
    },
    //Trigger vào các cột cấu hình khi data được submit
    changeTriggers: {
      default: [],
      type: Array,
    },
    /**
     * Cho phép người dùng tùy chỉnh cột lock
     * Mặc định là true
     */
    lockable: {
      type: Boolean,
      default: true,
    },
    /**
     * Có đếm dòng trống không
     * NXCHIEN 1708.2022
     */
    countEmptyRow: {
      type: Boolean,
      default: false,
    },
    /**
     * Nếu dòng dữ liệu có is_allow_edit thì được phép sửa
     * NXCHIEN 21.09.2022
     */
    isConfigReport: {
      default: true,
      type: Boolean,
    },

    /**
     * TTên của grid. Dùng để phân biệt các grid với nhau
     * NXCHIEN 21.09.2022
     */
    nameUnique: {
      default: '',
      type: String,
    },
    /**
     * Cấu hình cho phép sửa - báo cáo quyết toán
     * TPNAM 28/09/2022
     */
    allowEdit: {
      default: false,
      type: Boolean,
    },
    /**
     * Custom tên tiêu đề cho footer
     * dqdat1 05.10.2022
     */
    titleFooter: {
      default: '',
      type: String,
    },
    /**
     * Hiện thị emty data theo style
     * 1: Mặc định - Không có dữ liệu
     * 2: Không tìm thấy dữ liệu phù hợp
     */
    styleEmptyData: {
      default: 1,
      type: Number,
    },
    // Custom prop ẩn footer khi trống dữ liệu
    hideFooterEmpty: {
      default: false,
      type: Boolean,
    },

    /**
     * Cấu hình sao chép dữ liệu 1 cột xuống các cột khác (mục đích để dev phải check lại các màn hình đã làm để tránh lỗi dữ liệu)
     * NXCHIEN 02.11.2022
     */
    isCopyDataColumn: {
      default: false,
      type: Boolean,
    },

    /**
     * Có loại bỏ group khi chỉ có 1 column trong group không?
     */
    ignoreGroup: {
      default: true,
      type: Boolean,
    },

    /**
     * Biến này ko đưuọc phép dùng
     * NXCHIEN 04.01.2022
     */
    customControlType: {
      default: false,
      type: Boolean,
    },

    /**
     * biến này custom lại định dạng của cell
     * tvhien 18.01.2023
     */
    customCellEditor: {
      type: Function,
      default: null,
    },

    spanMethod: {
      type: Function,
      default: null,
    },
    /**
     * Có cộng thêm 1px của border cho footer không
     */
    addWidthBorderFooter: {
      type: Boolean,
      default: true,
    },
    linkedGroupField: {
      type: String,
      default: null,
    },
    recalculateSortOrder: {
      type: Boolean,
      default: false,
    },
    stepSortOrder: {
      type: Number,
      default: 1,
    },
    /**
     * Trường lưu id cha
     */
    fieldParentDrag: {
      type: String,
      default: '',
    },
    /**
     * Trường được lấy làm cha
     */
    fieldRootDrag: {
      type: String,
      default: '',
    },
    /**
     * Là grid kéo thả cha con
     */
    treeDrag: {
      type: Boolean,
      default: false,
    },
    /**
     * Không cho phép thêm bớt con vào cây grid
     */
    lockTreeDrag: {
      type: Boolean,
      default: false,
    },
    multipleErrorField: {
      type: Boolean,
      default: false,
    },
    // Hiện thị số dòng cho phép.
    lineBreak: {
      default: 1,
      type: Number,
    },
    // Text ở dạng textarea thay vì input
    textarea: {
      default: false,
      type: Boolean,
    },
    // Có thực hiện drag dòng không
    dragRow: {
      default: false,
      type: Boolean,
    },
    customUpdateChangeDragData: {
      default: null,
      type: Boolean,
    },
    /**
     * Có cache lại validate khi phân trang không
     * NXCHIEN 23.06.2023
     */
    validateCache: {
      default: true,
      type: Boolean,
    },

    // Sửa nhanh chứng từ
    isQuickEditVoucher: {
      type: Boolean,
      default: false,
    },

    // prop dùng cho sửa nhanh chứng từ
    configVoucherQuickEdit: {
      default: [],
      type: Array,
    },

    /**
     * Cho phép copy từ excel
     */
    allowCopyFromExcel: {
      default: false,
      type: Boolean,
    },
    /**
     * Config copy từ excel
     */
    configCopyExcel: {
      type: Object,
      default: null,
    },
    /**
     * Hiển thị dòng trống
     */
    showRowEmpty: {
      default: true,
      type: Boolean,
    },

    /**
     * Mảng chứa các phần tử khi click chuột phải
     * NXCHIEN 06.12.2023
     */
    itemRightClicks: {
      default: () => [],
      type: Array,
    },
    /**
     * Prop Điều kiện hiển thị phần tổng số dòng
     * False: Không đếm dòng empty
     * True: Đếm cả dòng empty
     */
    isCountEmptyRow: {
      default: false,
      type: Boolean,
    },
    /**
     * Biến đánh dấu grid có thể collapse hay không (vd: Grid màn RolePage)
     * HMDUC2 19.09.2024 
     */
    isGridCollapse:{
      default: false,
      type: Boolean,
    },

    /**
     * Trường đánh dấu validate theo dvc
     * dtnga3 (23.12.2024) sửa bug 712471
     */
    isValidateDvc: {
      default: false,
      type: Boolean,
    },
  },

  data() {
    return {
      // Dữ liệu combo khi filter cột local
      dataComboFilter: [],
      //Lưu dữ liệu cấu hình cột trong grid
      columnx: null,
      //Lưu dữ liệu cấu hình cột trong grid
      columnFull: null,
      //Cho sao chép/bôi đen dữ liệu hay không
      selectedTextMode: false,
      //Trang hiện tại
      currentPage: 1,
      //Dòng được chọn
      rowSelected: {},
      //Độ rộng của table
      widthx: 0,
      hasScroll: false,

      /**
       * Filter trên tiêu đề cột
       */
      filterHeader: [],
      //tổng số bản ghi
      totalCount: null,
      pageSizeInternal: 20,
      cacheValidatePaging: {},
      /**
       * Cache lại tham số sort
       */
      cacheSort: [],
      /**
       * header render
       */
      headers: [],

      /**
       * footer render
       */
      footers: [],

      listRowSelected: [],
      pageTotalCaptionData: this.$t('i18nComponent.Paging.Total'),

      /**
       * header render
       */
      firstLoad: true,

      /**
       * index của row đang focus
       */
      indexOfRowFocused: 0,

      /**
       * index của row đang được editor
       */
      indexOfRowEditor: -1,
      /**
       * Có cột lock
       */
      hasLockColumn: false,
      /**
       * danh sách columns bị lock
       */
      columnLocks: [],
      /**
       * Vị trí hiển thị của box empty
       */
      emptyStyle: {
        top: 0,
        left: 0,
        display: 'none',
      },
      /**
       * Text tìm kiếm của form cha
       */
      parentSearchText: '',
      /**
       * có scroll dọc không
       */
      hasScrollX: false,

      loading: true,
      checkedAll: false,
      selected: {},
      editor: true,
      colValue: {},
      /**
       * Kiểm tra xem dữ liệu có bị filter không
       * tbngoc 21.06.2023
       */
      isFiltered: false,

      /**
       * Item config sự kiện click chuột phải
       * NXCHIEN 06.12.2023
       */
      viewMenu: false,
      top: '0px',
      left: '0px',
      lastActiveElm: null,
    };
  },
  provide() {
    return {
      isCellEditor: this.isCellEditor,
      allowCopyFromExcel: this.allowCopyFromExcel,
    };
  },
  setup(props, {emit}) {
    const {changeColumnResize, handlerResizeOn} = useColumnResize({
      props,
      emit,
    });
    const {proxy} = getCurrentInstance();
    //Chuyển về shallowRef để giảm nhẹ tracking
    const datax = shallowRef([]);

    // data này chỉ dùng trong trưownfg hợp phân trang
    const dataxAllPagin = shallowRef([]);

    const updateAllState = (field, value) => {
      proxy.datax.forEach(x => {
        // loại bỏ những dòng disable
        //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
        if (x.hasOwnProperty('disabledState') && x['disabledState']) {
        } else {
          x[field] = value;
        }
      });

      proxy.colValue[field] = value;
    };
    //Provide API cập nhật all state
    provide('updateAllState', updateAllState);

    const spanMethod = (col, dataRow, colIndex) => {
      if (props.spanMethod && typeof props.spanMethod === 'function') {
        return props.spanMethod(col, dataRow, colIndex);
      }
    };

    provide('spanMethod', spanMethod);
    //Xử lý filter - NCPHUOC 23/06/2022
    const filterHandler = async ({col, value}) => {
      await proxy.submitEditor();
      const me = proxy;
      let check = me.filterHeader.filter(i => i.dataField == col.dataField);
      if (check.length == 0) {
        me.filterHeader.push(col);
      } else {
        me.filterHeader.forEach(item => {
          if (item.dataField == col.dataField) {
            item = col;
            return;
          }
        });
      }

      //Xóa giá trị filterHeader
      if (!value) {
        nextTick(() => {
          me.filterHeader = me.filterHeader.filter(i => i.dataField !== col.dataField);
        });
      }

      me.localFilter();
      if (me.pagination) {
        me.setPage(1);
      }
    };

    /**
     * Load combobox filter headder
     * NXCHIEN 22.5.2023
     */
    function loadColumnFilter(payload, row, column, col) {
      let me = proxy;
      emit('loadFilter', payload, row, column, col, me?.queryMode);
    }

    /**
     * Xử lý ẩn hiện dạng cây group
     * NCPHUOC 27/05/2022
     */
    const toggleTree = dataRow => {
      const data = proxy.groupData.find(x => x === dataRow);
      if (data) {
        data.expanded = !data.expanded;
        changeVisibleTr(data, data.expanded);
      }
    };

    /**
     * Đệ quy lấy các node con để ẩn hiện
     */
    const changeVisibleTr = (data, expanded) => {
      let childNodes = data.childNodes;
      if (!childNodes || childNodes.length === 0) {
        return;
      }
      // data.expanded = expanded;
      childNodes.forEach(item => {
        item.isHide = !expanded;
        changeVisibleTr(item, expanded);
      });
    };

    const {prepareDataBeforePaste} = useCopyFromExcel();

    /**
     * Xử lý sự kiện paste dữ liệu (Emit từ MsTrEditor)
     * nmtuan4 20.10.2023
     */
    const onPaste = (pasteData, startRowIndex) => {
      const me = proxy;
      // Chỉ khi cho phép copy từ excel thì gọi xử lý
      if (me.allowCopyFromExcel) {
        // Sau khi gọi hàm chuẩn bị dữ liệu thì mới xử lý copy
        prepareDataBeforePaste(pasteData, me.columnx, me.propsData)
          .then(() => {
            // Danh sách các dữ liệu cần copy
            let dataView = computed(() => me.dataView);
            if (typeof me.configCopyExcel?.customData == 'function') {
              dataView = computed(() => me.configCopyExcel?.customData(me.dataView));
              startRowIndex = dataView.findIndex(x => x[me.idField] == me.dataView[startRowIndex][me.idField]);
            }

            if (me.configCopyExcel?.autoAddRow) {
              let numberRowToAdd = pasteData.length - dataView.value.length + startRowIndex;

              for (let index = 0; index < numberRowToAdd; index++) {
                const indexDataView = dataView.value.length;
                me.addRow(null, indexDataView, true);
              }
            }

            // Lặp qua dữ liệu theo thứ tự
            for (let index = 0; index < pasteData.length; index++) {
              // Lấy dữ liệu tương ứng theo thứ tự
              const dataViewRow = dataView.value[startRowIndex + index];
              const pasteRow = pasteData[index];
              proxy.$nextTick(() => {
                if (dataViewRow && me.$refs[`trEditor_${dataViewRow[me.idField]}`]) {
                  let trEditor = me.$refs[`trEditor_${dataViewRow[me.idField]}`];
                  // Xử lý gọi hàm gán dữ liệu trong MsTrEditor
                  if (typeof trEditor[0].setRowValue == 'function') {
                    // Lấy dữ liệu kết quả paste
                    let pasteResult = trEditor[0].setRowValue(pasteRow);
                    for (const key in pasteRow) {
                      let col = me.columnx.find(x => x.dataField == key);
                      if (col) {
                        // Xử lý gọi updateRowChange để cập nhật dữ liệu theo nghiệp vụ (Mới xử lý đáp ứng cho input text và number)
                        me.updateRowChange(col, dataViewRow, pasteResult[col.dataField] || {});
                      }
                    }
                  }
                }
              });
            }

            me.resetValidate();
          })
          .finally(() => {
            emit('afterPaste', {});
          });
      }
    };

    /**
     * Bổ sung sự kiện click vào group
     * TODO=> Dev bắt sự kiện này ngoài form và check e.target.class có phải là text-link hay ko mới xử lý tiếp
     */
    const clickRowGroup = (e, groupRow, i) => {
      emit('clickRowGroup', e, groupRow, i);
    };
    const dbOptionHeight = computed(() => {
      return 'heightoptionvalue' + parseInt(proxy.$store?.state?.dbOption?.dbOptions.HeightOption || 2);
    });

    const dbOptionHeightWrapper = computed(() => {
      return 'heightoptionvalueMenuWrapper' + parseInt(proxy.$store?.state?.dbOption?.dbOptions.HeightOption || 2);
    });

    const dbOptionHeightWrapperLi = computed(() => {
      return 'heightoptionvalue-wrapper' + parseInt(proxy.$store?.state?.dbOption?.dbOptions.HeightOption || 2);
    });

    /**
     * set lại vị trí ẩn hiện khi click chuột phải
     * NXCHIEN 06.12.2023
     */
    function setMenu(top, left) {
      let largestHeight = window.innerHeight - proxy.$refs.rightClick.offsetHeight;
      let largestWidth = window.innerWidth - proxy.$refs.rightClick.offsetWidth;

      if (top > largestHeight) top = largestHeight;

      if (left > largestWidth) left = largestWidth;

      proxy.top = top + 'px';
      proxy.left = left + 'px';
    }

    /**
     * Đóng context chuột phải
     * NXCHIEN 06.12.2023
     */
    function closeMenu() {
      proxy.viewMenu = false;
    }

    /**
     * Mở context khi click chuột phải
     * NXCHIEN 06.12.2023
     */
    async function openMenu(e) {
      if (!proxy.itemRightClicks?.length) {
        return;
      }

      proxy.viewMenu = true;

      // item click có bị disabled ko, ko thì lấy luôn
      // có thì lấy ra tr sau đó tìm thằng đầu tiên ko bị disabled
      // nếu ko có cả tr thì vào thằng đầu tiên của grid
      let rowIndex = 0;

      if (e.target.closest('.custom-container:not(.disabled)')) {
        proxy.lastActiveElm = e.target.closest('.custom-container:not(.disabled)').closest('td');
        if (e.target.closest('tr').getVueInstance) {
          let obj = e.target.closest('tr').getVueInstance();
          rowIndex = obj.rowIndex;
        }
      } else if (e.target.closest('tr')) {
        proxy.lastActiveElm = e.target.closest('tr');
        if (e.target.closest('tr').getVueInstance) {
          let obj = e.target.closest('tr').getVueInstance();
          rowIndex = obj.rowIndex;
        }
      } else {
        proxy.lastActiveElm = e.target.closest('.ms-editor');
      }

      // submit sau khi lấy lastActiveElm
      await proxy.submitEditor();

      // thực hiện selectRow đang chuột phải
      const rowClick = proxy.dataView[rowIndex];
      if (rowClick) {
        proxy.dataView.forEach(x => (x.selected = false));
        rowClick.selected = true;
        proxy.rowSelected = _.cloneDeep(rowClick);
      }

      proxy.$nextTick(() => {
        proxy.$refs.rightClick.focus();
        setMenu(e.y, e.x);
      });

      e.preventDefault();
    }

    /**
     * Xử lý contextmenu click sự kiện chuột phải
     * NXCHIEN 06.12.2023
     */
    function handleActionRightClick(item) {
      // nếu ko có dòng dữ liệu nào thì thôi
      if (!proxy.dataView?.length || proxy.dataView.length == 0) {
        return;
      }

      // active vào cell đang chuột phải, nếu ko lấy được thì mặc định vào dòng đầu tiên
      if (item.isActive) {
        let ext = item.classDisabled ? `:not(${item.classDisabled})` : '';

        let $item = proxy.lastActiveElm;
        if ($item && $item.querySelector) {
          if ($item.querySelector('tbody tr')) {
            let $active = $item.querySelector(
              `tbody tr td${ext} .custom-container:not(.disabled) .ms-editor-text a.editor-click`,
            );
            if ($active) {
              $active.click();
            }
          } else if ($item.className.includes('tr')) {
            let $tempTr = $item.querySelector(
              `td${ext} .custom-container:not(.disabled) .ms-editor-text a.editor-click`,
            );
            if ($tempTr) {
              $tempTr.click();
            }
          } else if ($item.className.includes('td')) {
            let $parent = $item.closest('tr');
            let $tempTd = $parent.querySelector(
              `td${ext} .custom-container:not(.disabled) .ms-editor-text a.editor-click`,
            );
            if ($tempTd) {
              $tempTd.click();
            }
          }
        }
      }

      proxy.$nextTick(() => {
        if (!proxy._currentEditor && item.isActive) {
          closeMenu();
          return;
        }

        const { pushTrans } = collectionMonitor();

        switch (item.action) {
          case proxy.$ms.constant.Command.AddRow:
            proxy.shortKeyAddRow(proxy);
            pushTrans(proxy.$ms.constant.Command.InsertRowGrid, 'MsGridEditor', `RightClick/${proxy.$ms.constant.Command.InsertRowGrid}`);
            break;
          case proxy.$ms.constant.Command.DeleteRow:
            proxy.shortKeyDeleteRow(proxy);
            pushTrans(proxy.$ms.constant.Command.DeleteRowGrid, 'MsGridEditor', `RightClick/${proxy.$ms.constant.Command.DeleteRowGrid}`);
            break;
          default:
            emit('afterRightClickAction', proxy, item);
            pushTrans(proxy.$ms.constant.Command.ViewAccount, 'MsGridEditor', `RightClick/${proxy.$ms.constant.Command.ViewAccount}`);
            break;
        }

        closeMenu();
      });
    }

    return {
      changeColumnResize,
      handlerResizeOn,
      datax,
      dataxAllPagin,
      filterHandler,
      loadColumnFilter,
      toggleTree,
      clickRowGroup,
      dbOptionHeight,
      onPaste,
      setMenu,
      closeMenu,
      openMenu,
      handleActionRightClick,
      dbOptionHeightWrapper,
      dbOptionHeightWrapperLi,
    };
  },
  computed: {
    // biến hiển thị tổng số bản ghi
    pageTotalPaging() {
      const me = this;
      const data = me.pagination ? me.dataxAllPagin : me.datax;

      const filterFn = function (record) {
        if (me.isCountEmptyRow) {
          return record.state !== me.$ms.constant.ModelState.Delete && !record.isHiddenByFilter;
        }

        // lọc các bản ghi có trạng thái khác empty
        return (
          record.state !== me.$ms.constant.ModelState.Delete &&
          record.state !== me.$ms.constant.ModelState.Empty &&
          !record.isHiddenByFilter
        );
      };

      return data?.filter(filterFn)?.length ?? 0;
    },
    /**
     * Số lượng cột shimmer
     */
    shimmerColumn() {
      const me = this;
      let res = [];
      if (me.multiple) {
        res.push({
          offset: 0,
          lock: me.hasLockColumn,
        });
      }

      if (me.serial) {
        res.push({
          offset: me.multiple ? 60 : 0,
          lock: me.hasLockColumn,
        });
      }

      if (Array.isArray(me.columnx)) {
        me.columnx.forEach(item => {
          res.push({
            offset: item.stickyOffset,
            lock: item.lock,
          });
        });
      }

      if (me.$slots['widget-body']) {
        res.push({
          offset: 0,
          lock: me.hasLockColumn,
        });
      }

      return res;
    },
    dataView() {
       // HMDUC2 19.09.2024: Nếu grid có thể collapse thì return datax luôn để không bị reset dữ liệu về rỗng
      if(this.isGridCollapse){
        return this.datax;
      }
      let dataView = [];
      let me = this;
      //case lại cho trường hợp pagin
      if (this.pagination) {
        // biến này dùng dể watch giá trị thay đổi thì load lại dataview (khi thay dổi pagesize, page hiện tại, dữ liệu)
        let watchValue = `${this.pageSizeInternal}_${this.currentPage}_${this.dataxAllPagin?.length}_${this.dataViewAllPagin?.length}_${this.cacheSort}`;
        dataView = this?.getItemPagination() ?? [];
        // dtnga3 (12.04.2024) TH trang trước tích chọn tất cả, nhưng sang trang này DL ban đầu chưa tích chọn tất cả mà checkbox ở header lại hiển thị tích chọn thì sai nên cần cập nhật lại theo DL trên trang hiện tại
        me.checkedAll = me.isCheckedMultiple(me.modelValue, dataView);
        this.$nextTick(() => {
          // khi load xong data padgin thì load lại cache validate

          // HMDUC2: 14/05/2024: Load cache trong trường hợp grid 
          // validate lỗi ở page này nhưng đang ở page khác (case vớ grid có SummaryGroup)
          if(me.currentPage > 1 && me.isSummaryGroup){
            me.loadCacheValidatePagin(true);
          }else{
            me.loadCacheValidatePagin(false);
          }
        });
      } else {
        dataView = (this.disabled && this.preventEmptyDisabled)
          ? this.datax.filter(
              x =>
                x.state !== this.$ms.constant.ModelState.Delete &&
                x.state !== this.$ms.constant.ModelState.Empty &&
                !x.isHiddenByFilter,
            )
          : this.datax.filter(x => x.state !== this.$ms.constant.ModelState.Delete && !x.isHiddenByFilter);
        // Nếu là thực hiện drag dòng thì sẽ lấy dữ liệu theo dữ liệu đã sort sau khi drag
        // if (this.dragRow) {
        //   dataView.sort((a, b) => a.sort_order - b.sort_order);
        // }
      }
      return dataView;
    },
    dataViewAllPagin() {
      const dataView = this.disabled
        ? this.dataxAllPagin.filter(
            x =>
              x.state !== this.$ms.constant.ModelState.Delete &&
              x.state !== this.$ms.constant.ModelState.Empty &&
              !x.isHiddenByFilter,
          )
        : this.dataxAllPagin.filter(x => x.state !== this.$ms.constant.ModelState.Delete && !x.isHiddenByFilter);
      return dataView;
    },
    //Sự kiện từ 1 dòng dữ liệu emit ra ngoài
    listeners() {
      const me = this;
      return {
        /**
         * Emit sau khi select combobox
         * PQDat 30.03.2023
         */
        comboBoxSelectItem: (metaData, dataRow) => {
          const {col} = this._currentEditor;
          const rowIndex = this.dataView.findIndex(x => x === dataRow);
          me.$emit('comboBoxSelectItem', me, col, rowIndex, metaData.newData, me.updateRowBusiness.bind(me));
        },
        /**
         * Bổ sung check selectedRow
         * NCPHUOC 06/07/2022
         */
        cellClick: async (infor) => {
          const {colIndex, rowIndex, col} = infor;
          const rowClick = this.dataView[rowIndex];

          // Luôn submit editor trước khi xử lý click mới
          await this.submitEditor();

          if (rowClick) {
            this.dataView.forEach(x => (x.selected = false));
            rowClick.selected = true;
            me.$emit('cellClick', rowClick);
          }
          // Check cho trường hợp dragRow thì inactive cell đang chọn
          if (!colIndex && !col && this.dragRow) {
            if (this._currentEditor) {
              this._currentEditor.inactiveCell();
            }
          }

          this.changeEditor(colIndex, rowIndex, col);
        },

        dblclick_cell: (dataRow, event) => {
          me.$emit('dblClickEvent', dataRow, event);
        },
        [me.$ms.constant.CustomEvent.MsKeydown]: (event, rowIndex) => {
          me.row_keydown(event, rowIndex);
        },
        widgetEvent: (data, event) => {
          me.$emit('widgetEvent', data, event);
        },
        selected: metaData => {
          me.$emit('selected', metaData, me.rowSelected);
        },
        rowSelected: data => {
          me.updateRowSelected(data);
        },
        comboboxLoadData: (payload, row, col) => {
          me.$emit('comboboxLoadData', payload, row, col);
        },
        submitQuickAdd: () => {
          me.$emit('submitQuickAdd', arguments);
        },
        gridRowActionClick: (command, rowIndex) => {
          me.onRowActionClick(command, rowIndex);
        },
        gridRowStateClick: (metaData, rowIndex) => {
          me.onRowStateClick(metaData, rowIndex);
        },
        clickMultiple: (dataRow, rowIndex, checked, event) => {
          me.clickMultiple(dataRow, checked);
          me.$emit('clickMultiple', dataRow, checked);
        },
        viewLinkedForm: (col, dataRow, event) => {
          if (event) {
            event.target.focus();
          }
          me.$emit('viewLinkedForm', col, dataRow);
        },
        pasteInput: (pasteData, startRowIndex) => {
          me.onPaste(pasteData, startRowIndex);
        },
        callbackAddData: (dataRow, rowIndex) => {
          me.$emit('callbackAddData', dataRow, rowIndex);
        },
      };
    },
    scrollVisiable() {
      if (this.hasScroll) {
        return true;
      }
      return false;
    },
    lockCount() {
      let count = this.multiple ? 1 : 0;
      if (this.columnx) {
        for (let i = 0; i < this.columnx.length; i++) {
          let col = this.columnx[i];
          if (!col.lock) {
            break;
          }
          count++;
        }
      }
      return count;
    },
    gridViewStyle() {
      if (this.maxHeight) {
        return {
          'max-height': this.maxHeight,
          height: 'auto',
        };
      }
      return null;
    },
    //Style tính lại tọa độ cho footer khi có pagination
    bottomFooter() {
      const me = this;
      if (me.pagination && me.footer) {
        return {
          bottom: '46px',
        };
      } else {
        return {
          bottom: '0px',
        };
      }
    },
    dataEmpty() {
      // return false;
      if (this.dataView && this.dataView.length > 0) {
        return false;
      } else return true;
    },
  },
  created() {
    const me = this;
    me.initColumns();
    window.addEventListener('resize', me.windowResize);
  },
  mounted() {
    if (this.$refs.tableHeader) {
      this.widthx = this.$refs.tableHeader.offsetWidth;
    }
  },
  emits: [
    'update:list',
    'updateBusiness',
    'msRowClick',
    'afterDeleteRow',
    'onEditEventCellEditor',
    'onAfterEditEventCellEditor',
    'update:modelValue',
    'clickMultiple',
    'checkAllEvent',
    'dblClickEvent',
    'viewLinkedForm',
    'submitGridEditor',
    'copyDownRow',
    'clickRowGroup',
    'updateChangeDataDrag',
    'getSpaceLeft',
    'comboBoxSelectItem',
    'loadFilter',
    'copyActionClick',
    'changePageSize',
    'loadData',
    'cellClick',
    'updateAfterDrag',
    'updateSortOrder',
    'updateDataFiltered',
    'afterRightClickAction',
  ],
  watch: {
    data: {
      immediate: true,
      handler(newVal, oldVal) {
        try {
          let me = this;
          this.checkHasScroll();

          // nqhuy1 22/4/2024: Gán lại trang hiện tại trong trường hợp số trang trước đó > max page
          if (this.pagination) {
            const maxPage = Math.ceil((me.data?.length ?? 0) / (me.getPageSize() || 1));
            if (maxPage && me.currentPage > maxPage && me.queryMode == 'local') {
              me.setPage(maxPage);
            }
          }
          if (me.datax != newVal) {
            if (me.groupField) {
              me.$nextTick(() => {
                me.defaultExpand();
              });
            }
          }
          if (newVal && me.datax !== me.data) {
            me.initData(newVal);
            if (me.firstLoad && newVal.length > 0) {
              me.autoSelectedFirstRow(true);
            }

            if (Array.isArray(me.modelValue) && me.modelValue.length > 0) {
              me.checkedAll = me.isCheckedMultiple(me.modelValue);
            }
          }

          // vvkiet - 20.09.2021: Thêm code để hiển thị icon grid-no-data
          if ((!newVal || newVal.length === 0) && me.$el) {
            me.$nextTick(() => {
              let scroll = me.$refs.content;
              if (scroll) {
                let scrollPos = scroll.getBoundingClientRect();
                me.emptyStyle = {
                  top: [scrollPos.top + scrollPos.height / 2 - 95, 'px'].join(''),
                  left: [scrollPos.left + scrollPos.width / 2 - 125, 'px'].join(''),
                };
              }
              me.updateFooterContainer();
            });
          }
        } finally {
          this.loading = false;
        }
      },
    },
    searchText: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.triggerSearch();
        }
      },
    },
    datax: {
      handler(newVal, oldVal) {
        const me = this;
        // check selected các bản ghi khi mà load lại trang hoặc search làm thay đổi data grid
        if (Array.isArray(me.modelValue) && me.modelValue.length > 0) {
          me.checkedAll = me.isCheckedMultiple(me.modelValue);
        }
        //phải đặt nextick 2 lần do việc render data đang đặt trong nexttick và bản thân việc update này delay chút cũng k sao
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.updateFooterContainer();
          });
        });
      },
    },
    columns: {
      // ẩn hiện cột grideditor
      handler(newVal, oldVal) {
        this.initColumns();
      },
    },
    modelValue: {
      handler(newVal, oldVal) {
        //Do checkedAll là v-model của ô checkbox nên phải đợi khi flush hết job thay đổi của ô khi click mới thực hiện check lại xem đã check hết bản ghi trên grid chưa
        //NCPHUOC 11/07/2022
        nextTick(() => {
          setTimeout(() => {
            this.checkedAll = this.isCheckedMultiple(newVal);
          }, 0);
        });
      },
    },
    pageSize: {
      immediate: true,
      handler(newVal, oldVal) {
        this.pageSizeInternal = newVal;
      },
    },
  },
  methods: {
    /**
     * Thực hiện search
     */
    triggerSearch() {
      if (this.searchText || (this.filterObject && Object.keys(this.filterObject).length > 0)) {
        const properties = this.columnx.map(x => x.dataField);

        const treeData = [];
        //Cache lại những item đã được thêm vào để không cần duyệt mảng check
        const cacheExist = new Map();
        const idField = this.idField;
        const findParent = currentItem => {
          const isExist = cacheExist.get(currentItem[idField]);
          //Cache lại để đệ quy ko tìm vào item này nữa
          if (!isExist) {
            cacheExist.set(currentItem[idField], true);
          }

          if (currentItem.parentNode) {
            findParent(currentItem.parentNode);
          }
          //Thực hiện push ở sau để push các thằng cha vào trước
          if (!isExist) {
            treeData.push(currentItem);
          }
          return;
        };

        this.data.forEach(x => {
          let valid = commonFn.checkSearchText(x, properties, this.searchText);

          if (valid) {
            // lọc thêm theo bộ lọc khác
            if (this.filterObject && Object.keys(this.filterObject).length > 0) {
              valid = commonFn.checkFilterObject(x, this.filterObject);
            }

            if (valid) {
              findParent(x);
            }
          }
          return valid;
        });

        this.datax = treeData;
      } else {
        this.datax = [...this._cacheData];
      }
    },

    /**
      Lấy instance cell edit theo index
      NCPHUOC 15/04/2022
     */
    getCellEditor(colIndex, rowIndex) {
      const me = this;
      if (this.dataView && this.dataView[rowIndex]) {
        const pk = this.dataView[rowIndex][me.idField];
        const lastIndex = (me.$refs[`trEditor_${pk}`]?.length || 0) - 1;
        const trEditor = me.$refs[`trEditor_${pk}`]?.[lastIndex];
        if (trEditor) {
          const col = this.columnx[colIndex];
          const cellEditor = trEditor.$refs[`cellEditor_${col.dataField}`];
          if (Array.isArray(cellEditor)) {
            return cellEditor[0];
          }
        }
      }

      return null;
    },

    /**
    Xử lý các action thêm duplicate xóa trên dòng
    NCPHUOC 15/04/2022
     */
    async onRowActionClick(command, rowIndex) {
      const rowData = this.dataView[rowIndex];
      //Tìm chính xác index trong dữ liệu full để insert vào hoặc delete cho đúng
      const rowIndexOfFullData = this.pagination
        ? this.dataxAllPagin?.findIndex(x => x === rowData)
        : this.datax.findIndex(x => x === rowData);
      if (rowIndexOfFullData !== -1) {
        switch (command) {
          case 'Delete':
            this.deleteRow(rowData);
            break;
          case 'Duplicate':
            this.duplicateRow(rowData, rowIndexOfFullData);
            break;
          case 'Insert':
            // Trường hợp là dòng cuối cùng của trang thì submit grid trước khi sang trang
            if (rowIndex == this.pageSizeInternal - 1) {
              await this.submitEditor();
            }
            this.addRow(rowIndexOfFullData + 1, rowIndex + 1);
            break;
          case 'DeleteCustom':
            this.deleteRowCustom(rowData);
            break;
          //HTHIEP 21/10/2022
          default:
            this.$emit('cellAction', rowData);
            break;
        }
      }
    },
    /**
     * Click vào các row state
     * Modified by PQDat 27.03.2023 (Case treeDrag  tick cha tick hết con)
     */
    onRowStateClick(metaData, rowIndex) {
      const rowData = this.dataView[rowIndex];
      let parentIdField = this.fieldRootDrag;
      let idField = this.fieldParentDrag;
      if (metaData) {
        const {field} = metaData;
        const data = rowData[field];
        switch (typeof data) {
          case 'boolean':
            rowData[field] = data ? false : true;
            break;
          case 'number':
            rowData[field] = data ? 0 : 1;
            break;
          default:
            rowData[field] = data ? false : true;
            break;
        }
        if (this.treeDrag) {
          let paremtRowData = this.dataView.find(x => x[idField] == rowData[parentIdField]);
          if (!rowData[parentIdField] && this.dataView.some(x => x[parentIdField] == rowData[idField])) {
            this.dataView
              .filter(x => x[parentIdField] == rowData[idField])
              .forEach(item => {
                item[field] = rowData[field];
              });
          } else if (rowData[parentIdField] && rowData[field] && !paremtRowData[field]) {
            paremtRowData[field] = rowData[field];
          } else if (
            rowData[parentIdField] &&
            !rowData[field] &&
            !this.dataView.some(x => x[parentIdField] == paremtRowData[idField] && x[field])
          ) {
            paremtRowData[field] = rowData[field];
          }
        }

        let check = this.dataView.every(x => x.disabledState || x[field]);
        this.colValue[field] = check;
      }
    },

    /**
     * Lấy toàn bộ data đã thay đổi
     * NCPHUOC 29/03/2022
     * dtnga3 (27.07.2022) check rõ state với null và undefined thì mới filter được
     * NXCHIEN 17.08.2022: Thêm option đếm dòng trống
     */
    getDataChange() {
      if (this.countEmptyRow) {
        return this.datax.filter(x => x.state !== this.$ms.constant.ModelState.Delete && !x.isHiddenByFilter);
      }
      return this.datax.filter(
        x =>
          x.state !== this.$ms.constant.ModelState.Empty &&
          x.state !== this.$ms.constant.ModelState.Delete &&
          !x.isHiddenByFilter,
      );
    },
    /**
     * Tính toán xem có scroll ngang
     */
    updateHasScrollX() {
      const me = this,
        content = me.$refs.content;
      let scroll = false;
      if (content && content.clientWidth < content.firstElementChild.clientWidth) {
        scroll = true;
      }

      me.hasScrollX = scroll;
    },
    /// Dispose cell khi click ra ngoài
    onClickAway(e) {
      //Các container sẽ ko dispose cell
      const classes = [
        '.calendar-container.datepicker',
        '.combo-dropdown-panel',
        '.quick-add-container',
        '.quickAdd',
        '.quickAddMulti',
        '.fake-click',
        '.menu-wrapper-grid',
        '.row-editor-action.delete',
        '.menu-wrapper-right-click',
      ];

      const target = e.target;
      const dispose =
        classes.findIndex(className => {
          if (target.closest && (target.closest(className) || target.className.contains(className))) {
            return true;
          }
          return false;
        }) === -1;
      if (dispose) {
        // Muốn dispose được control thì phải click vào các item là con của class formId
        if (this.formId) {
          if (target.closest && (target.closest(`.${this.formId}`) || target.className.contains(`.${this.formId}`))) {
            this.submitEditor();
          }
        } else {
          this.submitEditor();
        }
      }
    },
    /**
     * Thực hiện submit control grid
     * NCPHUOC 05/04/2022
     */
    async submitEditor() {
      if (this._currentEditor && typeof this._currentEditor.inactiveCell === 'function') {
        //Lấy ra metadata trước khi cell bị dispose
        let metaData = {};

        if (typeof this._currentEditor.getMetaData === 'function') {
          metaData = this._currentEditor.getMetaData();
        }
        await this._currentEditor.inactiveCell();
        const {col, rowIndex} = this._currentEditor;
        //Lấy dataRow theo index đang hiện thị
        const dataRow = this.dataView[rowIndex];
        await this.updateRowChange(col, dataRow, metaData);
        if (this._currentEditor) {
          this._oldRowIndex = this._currentEditor.rowIndex;
          this._oldColIndex = this._currentEditor.colIndex;
        }
        delete this._currentEditor;
        this.$emit('submitGridEditor', this, col, dataRow);
      }
    },
    /**
     * Cập nhật row change khi submit 1 editor
     * NCPHUOC 07/04/2022
     * NCPHUOC 07/04/2022: Đổi state khi edit
     */
    updateRowChange(col, dataRow, metaData) {
      // return new Promise((resolve, reject) => {
      const me = this;
      if (me._cacheRow && me._cacheRow[col.dataField] === undefined) {
        me._cacheRow[col.dataField] = null;
      }
      if (dataRow && dataRow[col.dataField] === undefined) {
        dataRow[col.dataField] = null;
      }
      //Nếu có cấu hình trigger change và value bị thay đổi so với ban đầu
      if (dataRow && me._cacheRow && me._cacheRow[col.dataField] !== dataRow[col.dataField]) {
        //Nếu trạng thái của dòng là rỗng hoặc là insert sẽ chuyển thành insert, ngược lại thành edit
        dataRow.state =
          dataRow.state !== me.$ms.constant.ModelState.Empty && dataRow.state !== me.$ms.constant.ModelState.Insert
            ? me.$ms.constant.ModelState.Update
            : me.$ms.constant.ModelState.Insert;
        Object.assign(metaData, {
          tracking: {
            oldVal: me._cacheRow[col.dataField],
            newVal: dataRow[col.dataField],
          },
        });
        if (me.changeTriggers.includes(col.dataField)) {
          //Cập nhật dữ liệu business
          const rowIndex = this.dataView.findIndex(x => x === dataRow);
          me.$emit(
            'updateBusiness',
            me,
            col,
            rowIndex,
            metaData,
            me.updateRowBusiness.bind(me),
            // ()=>resolve()
          );
        }
      }
      // });
    },
    /**
    Hàm cập nhật row từ bên ngoài vào trong grid
    Mọi cập nhật phải gọi qua hàm này để tracking validate
     */
    updateRowBusiness(metaData, rowIndex) {
      if (metaData && typeof metaData === 'object' && rowIndex >= 0) {
        const row = this.dataView[rowIndex];

        for (const key in metaData) {
          const value = metaData[key];
          row[key] = value;
          const colIndex = this.columnx.findIndex(x => x.dataField === key);
          if (colIndex !== -1) {
            const column = this.columnx[colIndex];
            if (column.rules && column.rules.length > 0) {
              this.validateCell(colIndex, rowIndex);
            }
          }
        }
      }
    },
    /**
    validate 1 Cell cụ thể
    NCPHUOC 04/05/2022
     */
    validateCell(colIndex, rowIndex) {
      const editor = this.getCellEditor(colIndex, rowIndex);
      if (editor && typeof editor.validate === 'function') {
        const messageValidateCell = editor.validate();
      }
    },
    getSummaryDisplay(col, rowIndex, colIndex) {
      const me = this;
      let dataRender = '';

      //Thêm check col này có cấu hình summary hay ko - NCPHUOC 27/10/2022
      if (me.summary && col.summaryType) {
        dataRender = me.summary[col.dataField];
      } else {
        dataRender = col.summaryType
          ? summaryUtil.doFunction(
              me.pagination ? me.dataViewAllPagin : me.dataView,
              col.summaryType,
              col.dataField,
              col.formatType,
            )
          : col.footerText;
      }

      if (!dataRender && rowIndex === 0) {
        if (((me.multiple || me.serial) && colIndex === 1) || (!me.multiple && !me.serial && colIndex === 0)) {
          // if ((me.multiple && colIndex === 1) || (!me.multiple && colIndex === 0)) {
          if (me.pagination) {
            dataRender = me.isSummaryGroup ? '' : me.$t('i18nComponent.Grid.FooterSum'); // HMDUC2: 02/05/2024: Nếu như là footer của grid có dòng tổng theo group thì ẩn đi
            // để hiển thị ở col đầu tiên
          } else {
            let data = me.getDataChange();
            let text = me.$t('i18nComponent.Grid.FooterRowCount', [data ? data.length : 0]);

            if (this.titleFooter) {
              text = this.titleFooter;
            }

            if (typeof text === 'string') {
              dataRender = text;
            } else {
              dataRender = me.$t('i18nComponent.Grid.FooterSum');
            }
          }
        } else if (me.serial && me.isSummaryGroup && colIndex === 0) {
          dataRender = me.$t('i18nComponent.Grid.FooterSumGroup'); // HMDUC2: 02/05/2024: Nếu như là footer của grid có dòng tổng theo group và là col đầu tiên thì bind text cho col
        }
      }
      if ((colIndex === 0 && !col.summaryType) || col.summaryType == me.$ms.constant.SummaryType.RowCount)
        return dataRender;
      let value = me.$ms.format.formatData(dataRender, {
        formatType: col.dataFormat || col.formatType,
        optionFormat: col.optionFormat,
      });

      return value == '--' || value == '-' || value == '0' ? null : value;
    },

    //Kiểm tra xem grid có scroll hay không?
    checkHasScroll() {
      if (this.$refs.content) {
        if (this.$refs.content.getBoundingClientRect().height + 2 < this.$refs.content.scrollHeight) {
          this.hasScroll = true;
        } else {
          this.hasScroll = false;
        }
      }
    },
    //Cập nhật lại row được chọn để css
    updateRowSelected(data) {
      this.rowSelected = data;
    },

    /**
     * Xử lý filter local
     */
    localFilter() {
      const me = this;
      let data = reactive([]);
      for (let i = 0; i < me.data.length; i++) {
        let record = me.data[i];

        // đánh dấu là có đang bị ẩn bởi filter không. mặc định là có khi pass qua điều kiện lọc thì gán lại bằng false (khi phân trang sễ lọc theo trường này)
        record.isHiddenByFilter = true;

        let f = true;
        for (let j = 0; j < me.columnx?.length || 0; j++) {
          let col = me.columnx[j];

          if (col.filter) {
            let opWithValue = true;
            switch (col.filter.operator) {
              case me.$ms.constant.FilterOperator.Null:
              case me.$ms.constant.FilterOperator.NotNull:
                opWithValue = false;
                break;
              default:
                break;
            }

            if (opWithValue) {
              if (col.filter.value !== null && col.filter.value !== '' && typeof col.filter.value !== 'undefined') {
                const fn = this.genFilterFunction([{...col.filter, ...{property: col.dataField}}]);
                let test = fn(record, col);

                if (!test) {
                  f = false;
                  break;
                }
              }
            } else {
              const fn = this.genFilterFunction([{...col.filter, ...{property: col.dataField}}]);
              let test = fn(record, col);
              if (!test) {
                f = false;
                break;
              }
            }
          }
        }
        if (!f) {
          continue;
        }
        // khi phân trang sẽ fiter theo trường này
        record.isHiddenByFilter = false;
        data.push(record);
      }
      if (me.dragRow) {
        me.datax.sort((a, b) => a.sort_order - b.sort_order);
      }

      if (me.data.length !== me.datax.length) {
        me.isFiltered = true;
        me.$emit('updateDataFiltered', true);
      } else {
        me.$emit('updateDataFiltered', false);
        me.isFiltered = false;
      }

      me.totalCount = data.length;
    },
    /**
     * Xóa hết filter hiện tại
     */
    clearFilter() {
      let me = this;
      for (let j = 0; j < me.columnx?.length || 0; j++) {
        let col = me.columnx[j];
        delete col.filter;
      }
      me.localFilter();
    },

    /**
     * Kiểm tra xem cột được check hay không ?
     * duyệt trong data nếu có chưa dữ liệu của dòng tương ứng thì return true ngược lại false
     * @param dataRow dữ liệu của dòng được check
     * Created by LTDAT 24.06.2020
     *  */
    isSelected(dataRow) {
      const me = this;
      if (me.selected && me.selected.length > 0) {
        return this.selected.findIndex(x => x[me.idField] === dataRow[me.idField]) === -1 ? false : true;
      }
      return false;
    },
    //Sự kiện ấn vào nút chọn tất cả bên trên header
    changeCheckedMultiple(e) {
      const me = this;
      let VModel = [...me.modelValue];
      const checked = e.target.tagName.toLowerCase() === 'input' ? e.target.checked : false;

      if (!checked) {
        let data = me.dataView.filter(i => !i.isDisabledCheckBox);

        data.forEach(dataRow => {
          const existed = VModel.find(x => x[me.idField] === dataRow[me.idField]);
          if (existed) {
            VModel.remove(existed);
          }
        });
      } else {
        let data = me.dataView.filter(i => !i.isDisabledCheckBox);
        data.forEach(dataRow => {
          const existed = VModel.find(x => x[me.idField] === dataRow[me.idField]);

          if (!VModel.includes(existed)) {
            VModel.push(dataRow);
          }
        });
      }

      me.$emit('update:modelValue', VModel);

      // this.$nextTick(() => {
      //   if (me.checkedAll) {
      //     me.$emit('update:modelValue', [...me.dataView]);
      //   } else {
      //     me.$emit('update:modelValue', []);
      //   }

      // });
      me.dataView.forEach(x => (x.checked = me.checkedAll));
      me.$emit('checkAllEvent', me.checkedAll);
    },
    /**
     * Hàm xử lý sự kiện khi click vào ô check multiple
     * @param dataRow dữ liệu của dòng được chọn
     */
    clickMultiple(dataRow, checked) {
      const me = this;
      let VModel = me.modelValue ? [...me.modelValue] : [];
      const index = VModel.findIndex(x => x[me.idField] === dataRow[me.idField]);

      if (!checked) {
        VModel = VModel.filter(x => x[me.idField] !== dataRow[me.idField]);
      } else {
        if (index === -1) {
          VModel.push(dataRow);
        }
      }

      me.$emit('update:modelValue', VModel);
    },
    /**
     * Kiểm tra xem tất cả dữ liệu có đang được check hay không
     * modifiedBy dtnga3 (12.04.2024) nếu truyền data vào thì check data có đang check chọn hết không, không truyền thì check dataView như luồng cũ
     */
    isCheckedMultiple(selected, dataView = this.dataView) {
      const me = this;
      if (selected && dataView?.length > 0) {
        // xử lý gán lại model
        if (dataView && dataView.length) {
          dataView.forEach(item => {
            if (selected.find(x => x[this.idField] === item[this.idField])) {
              item.checked = true;
            } else {
              delete item.checked;
            }
          });
        }

        return (
          selected.length >= dataView.length &&
          dataView.every((item, index) => {
            return selected.findIndex(dataRow => dataRow[me.idField] === item[me.idField]) === -1 ? false : true;
          })
        );
      }
      return false;

      // if (this.modelValue && this.dataView.length > 0) {
      //   return this.modelValue.length === this.dataView.length;
      // }
    },

    //Đóng sự kiện resize cột trên grid
    //created by LTDAT(29.05.2020)
    //TVDAT 24/05/2023 emit thêm thông tin cột đang resize
    resizeClose(currentCol) {
      const me = this;
      //Cho phép bôi đên text
      me.selectedTextMode = false;

      //tính toán xem có scroll ngang không
      me.updateHasScrollX();

      //cập nhật footer
      if (me.footer) {
        me.initFooterColumn(me.columnx);
      }
      //Lưu lại thông tin layout, ghi nhớ độ rộng cột theo hành động người dùng TVDAT 19/04/2023
      me.$emit('resizeStop', me.columnx, currentCol);
    },
    /**
     * Khởi tạo dữ liệu ban đầu cho grid
     * columns truyền vào mặc định là columns trong props có thể truyền cấu hình khác từ ngoài vào
     */
    initColumns(columns = this.columns) {
      const me = this;
      columns = columns || [];
      me.columnx = [];
      // buid columnx
      function addColumnx(col) {
        if (col.childs && Array.isArray(col.childs)) {
          col.childs.forEach(item => addColumnx(item));
        } else {
          me.columnx.push(col);
        }
      }
      columns.forEach(col => addColumnx(col));

      me.setDefaultFieldColumn(me.columnx);
      if (!me.columnx) {
        me.columnx = [];
      }

      me.columnx = me.getVisiableColumn(me.columnx);
      const columnsResize = me.columnx.filter(x => x.dataField !== 'rowAction' && x.dataField !== 'rowState');
      let hasFlex = columnsResize.some(item => {
        return !item.width;
      });

      //Xóa width của 1 ô bất kỳ nếu tất cả các ô đều có width
      if (hasFlex == false && columnsResize.length > 1) {
        // delete me.columnx[Math.round(me.columnx.length / 2)].width;
        const lastColumn = columnsResize[columnsResize.length - 1];
        lastColumn['minWidth'] = lastColumn.width;

        delete lastColumn.width;
      }

      //xử lý group header
      me.initHeader(columns);

      columns.forEach(x => {
        switch (x.columnType) {
          case me.$ms.constant.ColumnType.State:
            me.colValue[x.dataField] = false;
            break;
        }
      });

      //gán stickty left cho các cột sticky
      me.$nextTick(() => {
        //tính toán xem có scroll ngang không
        me.$nextTick(() => {
          me.updateHasScrollX();
          me.updateStickyOffset();
        });

        //nếu có footer thì sử lý
        if (me.footer) {
          setTimeout(() => {
            me.initFooterColumn(me.columnx);
            me.updateFooterContainer();
          }, 300);
        }
      });
    },
    /**
     * Xử lý tiêu đề cột
     */
    initHeader(columns) {
      const me = this,
        headers = [],
        sub = [];
      columns = columns?.filter(x => x.visible != false);
      if (columns.length > 0) {
        let group;
        const length = columns.length;
        const lastCol = columns[length - 1];
        columns.forEach(x => {
          //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
          if (x.hasOwnProperty('last')) {
            delete x.last;
          }
        });
        //Nếu có cột rowAction thì gắn flag để ẩn hiện border ở cột cuối
        if (lastCol && lastCol.dataField === 'rowAction' && columns[length - 2]) {
          columns[length - 2].last = true;
        }
        columns.forEach((item, i) => {
          //gán lại filterable của mỗi cột (khi không truyền filterable trong columns)
          if (item.filterable !== false) {
            item.filterable = true;
          }
          if (item.group) {
            if (!group || group.caption !== item.group) {
              group = {
                isGroup: true,
                colspan: 1,
                caption: item.group,
                childs: [],
              };
              headers.push(group);
            } else {
              group.colspan++;
            }
            group.childs.push(item);
            sub.push(item);
          } else {
            headers.push(item);
          }
          //Auto xóa width ở cột cuối để autoresize và co kéo
          // if (item.last) {
          //   delete item.width;
          // }
        });

        //duyệt xử lý các nhóm cột chỉ có 1 phần từ -> bỏ nhóm đi
        if (me.ignoreGroup) {
          for (let i = 0; i < headers.length; i++) {
            let col = headers[i];
            if (col.childs) {
              if (col.childs.length === 1) {
                let child = col.childs[0];
                headers[i] = child;
                sub.remove(child);
              }
              //delete col.childs;
            }
          }
        }

        // buid subheader nhiều cấp
        function addSubHeader(header, grade) {
          if (me.headers[grade] && Array.isArray(me.headers[grade])) {
            me.headers[grade].push(header);
          } else {
            me.headers[grade] = [header];
          }
          if (header.childs && Array.isArray(header.childs)) {
            header.childs.forEach(item => addSubHeader(item, grade + (header.rowspan ?? 1)));
          }
        }
        me.headers = [];
        headers.forEach(x => addSubHeader(x, 0));

        // if (sub.length > 0) {
        //   me.headers = [headers, sub];
        // } else {
        //   me.headers = [headers];
        // }
      }
    },

    /**
     * Cập nhật footer container with
     * phải đợi data render xong để xem có scroll dọc không còn update lại width
     * NCPHUOC 29/03/2022: Check width != 0 cho TH grid đang bị ẩn
     */
    updateFooterContainer() {
      const me = this,
        width = me.$refs.content?.clientWidth;

      if (width && me.$refs.tableFooter) {
        me.$refs.tableFooter.style.width = width + 'px';
      }
    },

    /**
     * Xử lý tiêu đề cột
     */
    initFooterColumn(columns) {
      const me = this,
        footers = [],
        sub = [],
        thead = me.$refs.thead;

      let group;
      let columx = JSON.parse(JSON.stringify(columns));
      if (me.multiple) {
        columx.insertAt(0, {
          stickyOffset: 0,
          colspan: 1,
          dataField: 'multiple',
          width: columx[0]?.stickyOffset,
        });
      }
      if (me.serial) {
        columx.insertAt(0, {
          stickyOffset: 0,
          colspan: 1,
          dataField: 'serial',
          width: columx[0]?.stickyOffset,
        });
      }
      if (
        columx.length > 1 &&
        me.serial &&
        (!columx[1].summaryType || columx[1].summaryType == me.$ms.constant.SummaryType.RowCount)
      ) {
        columx[1].classes = 'footer-total-count';
      } else if (
        columx.length > 0 &&
        (!columx[0].summaryType || columx[0].summaryType == me.$ms.constant.SummaryType.RowCount)
      ) {
        columx[0].classes = 'footer-total-count';
      }
      columx.forEach((col, i) => {
        let item = {
          dataField: col.dataField,
          align: col.align,
          formatType: col.formatType,
          footerText: col.footerText,
          summaryType: col.summaryType,
          stickyOffset: col.stickyOffset,
          classes: col.classes,
          colspan: 1,
          width: col.width,
          isSummaryGr: me.isSummaryGroup,
        };

        if (thead) {
          let th = thead.querySelector(['th[field="', col.dataField, '"]'].join(''));
          if (th) {
            item.width = th.clientWidth || item.width;
            if (me.lockCount > 0 && me.lockCount === i + 1) {
              item.width += 1; //+1 do border lock
            }
          }
        }
        footers.push(item);
      });

      me.footers = [footers];
      return;
    },
    /** Lấy ra các column có thuộc tính visible = true
     * Created by LTDAT 17.07.2020
     * */
    getVisiableColumn(columns) {
      this.columnFull = columns;
      return columns.filter(item => {
        return item.visible == true;
      });
    },
    /**
     * Cập nhật left cho các cột stickey
     */
    updateStickyOffset() {
      const me = this,
        ths = me.$el.querySelectorAll('.ms-th'),
        columns = me.columnx;
      let usingColumnSetting = false;
      var row_group = me.$el.querySelectorAll('.row-group');
      let offset = 0;
      let f = 0;
      let width = 0;
      if (me.multiple && ths.length > 0) {
        width = ths[f]?.getBoundingClientRect()?.width || 0;
        // trường hợp grid bị ẩn đi -> offset của ô checkbox bị = 0; (lưu ý trên form có 2 grid trên 2 ms-tap-item khác nhau thì grid ở tab không actice sẽ bị lỗi left sticky)
        if (width === 0) {
          usingColumnSetting = true;
          width = 53; // me.$ms.constant.StyleCheckBoxMulti.Width;
        }
        offset += width;
        f++;
      }

      if (me.serial) {
        me.serialOffsetLeft = offset ? [offset, 'px'].join() : '0';

        width = ths[f]?.getBoundingClientRect()?.width || 0;
        // trường hợp grid bị ẩn đi -> offset của ô checkbox bị = 0; (lưu ý trên form có 2 grid trên 2 ms-tap-item khác nhau thì grid ở tab không actice sẽ bị lỗi left sticky)
        if (width === 0) {
          width = 60;
        }
        usingColumnSetting = true;
        offset += width;
        f++;
      }

      me.hasLockColumn = false;
      let i = 0;
      // Biến lưu tổng số các cột con
      let numberRowGroup = 0;
      // Biến lưu tên con cha
      let nameGroup = '';
      for (; i < me.columnx.length; i++) {
        let col = me.columnx[i];
        if (!col.lock) {
          break;
        }

        me.hasLockColumn = true;
        col['stickyOffset'] = offset;

        let pos = 0;
        if (!usingColumnSetting) {
          pos = ths[i + f].getBoundingClientRect();
        } else {
          pos = {width: columns[i + f - 1].width};
        }
        if (col.group) {
          // Nếu vẫn là con của cột cha đang được lưu
          if (nameGroup != col.group) {
            row_group[numberRowGroup].style.left = `${offset}px`;
            row_group[numberRowGroup].style['z-index'] = 3;
            nameGroup = col.group;
            numberRowGroup++;
          }
        }
        offset += pos.width;
      }

      // nameGroup = '';
      // numberRowGroup = 0;
      //remove offset column not locked
      for (let j = i; j < me.columnx.length; j++) {
        let col = me.columnx[j];
        col['stickyOffset'] = null;

        if (col.group) {
          // Nếu vẫn là con của cột cha đang được lưu
          if (nameGroup != col.group) {
            row_group[numberRowGroup].style.left = ``;
            row_group[numberRowGroup].style['z-index'] = '';
            nameGroup = col.group;
            numberRowGroup++;
          }
        }
      }

      me.initFooterColumn(me.columnx);
    },

    stickeyCountClass() {
      if (this.columnx) {
        let count = this.multiple ? 1 : 0;
        for (let i = 0; i < this.columnx.length; i++) {
          let col = this.columnx[i];
          if (!col.lock) {
            break;
          }
          count++;
        }

        if (count > 0) {
          return ['sticky', count].join('-');
        }
      }
      return null;
    },
    /**
     * Set giá trị default cho cấu hình cột
     * Created by LTDAT(17.07.2020)
     */
    setDefaultFieldColumn(columns) {
      //Nếu không cấu hình field hiện thị thì mặc định là true
      const me = this;
      if (columns && Array.isArray(columns)) {
        columns.forEach(item => {
          if (item.visible != false) {
            item.visible = true;
          }
          //món này là lock range nên sẽ không đặt cấu hình từng cột mà ăn chung theo grid
          item.lockable = me.lockable;
          //set columnType
          if (typeof item.columnType !== 'number') {
            me.setDefaultColumnType(item);
          }

          //nếu không chỉnh định thì để align mặc dịnh theo format type
          if (!item.align) {
            switch (item.columnType) {
              case me.$ms.constant.ColumnType.Number:
                item.align = 'right';
                break;
              case me.$ms.constant.ColumnType.Checkbox:
              case me.$ms.constant.ColumnType.Action:
              case me.$ms.constant.ColumnType.State:
              case me.$ms.constant.ColumnType.Datepicker:
              case me.$ms.constant.ColumnType.Order:
                item.align = 'center';
                break;
            }
          }

          //tvloi(17/05/2021) - Gán width mặc định
          if (item) {
            Object.assign(item, {_width: item.width});
          }
        });
      }
    },
    /**
     * Gán giá trị mặc định cho columnType của cấu hình cột
     * @param {Object} col: cấu hình cột
     * @author NVLAM 18.12.2020
     */
    setDefaultColumnType(col) {
      const me = this,
        FormatType = me.$ms.constant.FormatType;
      switch (col.formatType) {
        case FormatType.List:
          col.columnType = me.$ms.constant.ColumnType.Combobox;
          break;
        case FormatType.Checkbox:
          col.columnType = me.$ms.constant.ColumnType.Checkbox;
          break;
        case FormatType.Progress:
        case FormatType.Number:
        case FormatType.Quantity:
        case FormatType.QuantityConvert:
        case FormatType.UnitPrice:
        case FormatType.UnitPriceOC:
        case FormatType.AmountOC:
        case FormatType.Amount:
        case FormatType.ComboboxAmount:
        case FormatType.ExchangeRate:
        case FormatType.Rate:
        case FormatType.Allocation:
          col.columnType = me.$ms.constant.ColumnType.Number;
          break;
        case FormatType.Date:
        case FormatType.DateTime:
        case FormatType.Time:
          col.columnType = me.$ms.constant.ColumnType.Datepicker;
          break;
        case FormatType.Order:
          col.columnType = me.$ms.constant.ColumnType.Order;
          break;
      }
    },
    //Gán giá trị để render data có thể truyền từ ngoài vào
    initData(data = this.data || []) {
      const me = this;
      let dataSource = [];
      //Tự động gen pk nếu data chưa có
      me.autoGenPrimaryKey(data);
      // vvkiet - 20.09.2021: Thêm code để hiển thị icon grid-no-data
      if (me.$parent.searchText && me.$parent.searchText.length > 0) {
        me.parentSearchText = me.$parent.searchText;
      }

      if (data) {
        dataSource = data;
      }
      commonFn.genVKeyValue(dataSource);
      //nếu muốn mặc định selected những dòng nào thì truyền qua biến này
      if (me.modelValue) {
        me.listRowSelected = me.modelValue;
      }

      //Thực hiện filter data theo bộ lọc mới nhất
      me.localFilter();

      if (me.pagination) {
        me.dataxAllPagin = dataSource;
        me.cacheValidatePaging = {};
      } else {
        //Lấy dữ liệu từ server
        //Tạm gán = props data sau gán = gì khác tính sau
        me.datax = dataSource;
      }

      me._cacheData = [...me.data];

      me.columnx?.forEach(x => {
        switch (x.columnType) {
          case me.$ms.constant.ColumnType.State:
            me.colValue[x.dataField] = me.dataView.every(o => o.disabledState || o[x.dataField]);
            break;
        }
      });

      // me.$nextTick(() => {
      // 	this.checkHasScroll();
      // });
    },

    //Tự động gen pk nếu data chưa có
    autoGenPrimaryKey(dataSource) {
      if (Array.isArray(dataSource)) {
        dataSource.forEach(item => {
          if (!item[this.idField]) {
            item[this.idField] = commonFn.generateUUID();
          }
        });
      }
    },
    //Lấy dữ liệu của dòng được chọn
    getRowSelected() {
      const me = this;
      return me.rowSelected;
    },
    /*
     * pvduy 07/09/2021: hàm có thể cho phép từ form chứa grid có thể cập nhật ds bản ghi được chọn.
     */
    updateValueSelected(dataSelected) {
      const me = this;
      me.modelValue = dataSelected;
    },

    //Cập nhật lại scroll khi tab vào ô đang bị che bởi các cột sticky NCPHUOC 17/06/2022
    updateScrollWhenTabPress() {
      const me = this;
      const scroller = me.$el.querySelector('.scroller');
      const editor = me._currentEditor;
      const footer = me.$el.querySelector('tfoot .ms-tr');
      const header = me.$el.querySelector('.ms-thead .ms-tr');
      const footerHeight = footer ? footer.clientHeight : 0;
      const headerHeight = header ? header.clientHeight : 0;
      var tr = me.$el.querySelector('tbody .ms-tr');
      var reactTr = tr.getBoundingClientRect();
      if (editor && editor.$el) {
        const {rowIndex} = editor;
        const rowHeight = reactTr.height;
        const distance = rowHeight * (rowIndex + 1);
        if (distance > scroller.clientHeight + scroller.scrollTop - footerHeight - headerHeight) {
          scroller.scrollTop += distance - (scroller.clientHeight + scroller.scrollTop - footerHeight - headerHeight);
        }

        const rectScoller = scroller.getBoundingClientRect();
        const rectCurEditor = editor.$el.getBoundingClientRect();
        if (rectCurEditor.x > rectScoller.width / 2) {
          const hasColumnAction = me.columnx.some(x => x.dataField === 'rowAction');
          if (hasColumnAction) {
            const $rowAction = me.$el.querySelector('th.rowAction');
            if ($rowAction) {
              const rectRowAction = $rowAction.getBoundingClientRect();
              if (rectCurEditor.x + rectCurEditor.width > rectRowAction.x) {
                const scrollLeft = rectCurEditor.width - (rectRowAction.x - rectCurEditor.x);
                scroller.scrollLeft += scrollLeft;
              }
            }
          }
        } else {
          //Nếu col đã được lock thì bỏ qua luôn
          if (!editor.col.lock) {
            let lastIndexColLock = -1;
            this.columnx.forEach((col, index) => {
              if (col.lock) {
                lastIndexColLock = index;
              }
            });

            if (lastIndexColLock > -1) {
              const lastColLock = this.columnx[lastIndexColLock];
              //Tìm ra col lock cuối cùng
              const $colEl = me.$el.querySelector(`th.${lastColLock.dataField}`);
              if ($colEl) {
                //Tính toán xem có ẩn bởi cột sticky hay không
                const rectColLock = $colEl.getBoundingClientRect();
                if (rectColLock.x + rectColLock.width > rectCurEditor.x) {
                  const scrollLeftMinus = rectColLock.x + rectColLock.width - rectCurEditor.x;
                  if (scroller.scrollLeft >= scrollLeftMinus) {
                    scroller.scrollLeft -= scrollLeftMinus;
                  }
                }
              }
            }
          }
        }
      }
    },

    /**
     * Check xem vị trí con trỏ trên text có được action tiếp theo phím tắt hay ko
     * NCPHUOC 20/07/2022
     */
    checkCursorExecuteAction(e) {
      const input = e.currentTarget;
      if (input) {
        const {selectionEnd, selectionStart} = input;
        //Trường hợp ko bôi chữ nào
        if (selectionEnd === selectionStart) {
          if (selectionEnd === 0 && e.keyCode === this.$ms.constant.KeyCode.ArrowLeft) return true;
          if (selectionEnd === input.value.length && e.keyCode === this.$ms.constant.KeyCode.ArrowRight) return true;
        } else {
          if (selectionEnd - selectionStart === input.value.length) return true;
        }
      }
    },
    //Xử lý sự kiện ấn phím trên row
    //Created by LTDAT(15.06.2020)
    async row_keydown(e, rowIndex) {
      const me = this;
      switch (e.keyCode) {
        case this.$ms.constant.KeyCode.Tab:
          //Chặn luôn sự kiện tab mặc định do đã xử lý hết trong này => trường hợp tab vào ô checkbox đã có fake input
          e.preventDefault();
          if (e.shiftKey) {
            await me.pre(e);
          } else {
            await me.next(e);
          }

          this.$nextTick(() => {
            me.updateScrollWhenTabPress();
          });
          break;
        case this.$ms.constant.KeyCode.Enter:
          me.next(e);
          break;
        case this.$ms.constant.KeyCode.ESC:
          //Submit bằng ESC sẽ thực hiện roll lại row cũ cho người dùng
          e.stopPropagation();
          me.submitEditor().then(() => {
            if (me._cacheRow) {
              let mappingIndex = me.datax.findIndex(x => x === me.dataView[rowIndex]);
              if (mappingIndex !== -1) {
                me.datax[mappingIndex] = {...me._cacheRow};
              }
              delete me._cacheRow;
            }
            this.$nextTick(() => {
              const container = document.querySelector('.vfm__container');
              if (container) {
                container.focus();
              }
            });
          });

          break;
        case this.$ms.constant.KeyCode.Digit2:
        case this.$ms.constant.KeyCode.NumberPad2:
          //Nếu có config propsData của column là isNotCopy = true (cột không được copy) thì chỉ ngăn sự kiện mặc định của trình duyệt (sự kiện chuyển sang tab kế tiếp)
          if (e.ctrlKey && me._currentEditor && me._currentEditor.propsData?.isNotCopy && me.isCopyDataColumn) {
            e.preventDefault();
            return;
          }

          if (e.ctrlKey && me._currentEditor && me.isCopyDataColumn) {
            e.preventDefault();
            const {rowIndex, colIndex} = me._currentEditor;
            let countData = me.pagination ? me.dataView.length : me.datax.length;
            if (rowIndex < countData - 1) {
              const column = me.columnx[colIndex];
              const value = me._currentEditor.getValue();
              let objAssign = {[column.dataField]: value};

              // dtnga3 (20.06.2023) đoạn lấy lastIndexView thay cho hàm findLastIndex vì hàm này k hỗ trợ trên FireFox và Microsoft Edge
              let dataView = _.cloneDeep(me.dataView);
              let lastItem = dataView
                .reverse()
                .find(
                  x => x.state !== me.$ms.constant.ModelState.Empty && x.state !== me.$ms.constant.ModelState.Delete,
                );
              let lastIndexView = me.dataView.indexOf(
                me.dataView.find(x => lastItem && x[me.idField] == lastItem[me.idField]),
              );
              if (
                column.columnType === me.$ms.constant.ColumnType.Combobox ||
                column.columnType === me.$ms.constant.ColumnType.Enum
              ) {
                // Biến check xem metaData lấy từ xổ combo hay lấy từ dòng dữ liệu
                let isShowCombo = true;

                let metaData = me._currentEditor.getMetaData();
                //Th chưa chọn gì combo
                if (JSON.stringify(metaData) === '{}') {
                  metaData = me.dataView[rowIndex];
                  isShowCombo = false;
                }

                if (lastIndexView !== -1 && lastIndexView > rowIndex) {
                  //Emit ra ngoài các form tự xử lý trường hợp là combo
                  this.$emit(
                    'copyDownRow',
                    objAssign,
                    metaData,
                    column,
                    me,
                    lastIndexView,
                    rowIndex,
                    isShowCombo,
                    me.updateRowBusiness.bind(me),
                  );
                }
              } else {
                let metaData = me.dataView[rowIndex];
                if (lastIndexView !== -1 && lastIndexView > rowIndex) {
                  //Emit ra ngoài các form tự xử lý trường hợp là combo
                  this.$emit(
                    'copyDownRow',
                    objAssign,
                    metaData,
                    column,
                    me,
                    lastIndexView,
                    rowIndex,
                    false,
                    me.updateRowBusiness.bind(me),
                  );
                }
              }

              if (objAssign) {
                if (lastIndexView !== -1 && lastIndexView > rowIndex) {
                  for (let index = rowIndex + 1; index < lastIndexView + 1; index++) {
                    const element = me.dataView[index];
                    for (const key in objAssign) {
                      //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
                      if (Object.hasOwnProperty.call(objAssign, key)) {
                        const val = objAssign[key];
                        element[key] = val;
                      }
                    }
                    commonFn.changeStateRow(element);
                  }
                }
              }
              //Thực hiện validate lại cả grid
              me.validate();
            }
            return;
          }
          break;
        //NCPHUOC 25/10/2022: xử lý phím tắt ctrl down để copy xuống tất cả dòng dưới
        case this.$ms.constant.KeyCode.Down:
          me.downRow();
          break;
        case this.$ms.constant.KeyCode.Up:
          me.upRow();
          break;

        case this.$ms.constant.KeyCode.ArrowRight:
          if (me.checkCursorExecuteAction(e)) {
            //Chặn sự kiện scroll và phím tắt ngoài form
            e.preventDefault();
            await me.next(e);
            this.$nextTick(() => {
              me.updateScrollWhenTabPress();
            });
          }
          break;
        case this.$ms.constant.KeyCode.ArrowLeft:
          if (me.checkCursorExecuteAction(e)) {
            //Chặn sự kiện scroll và phím tắt ngoài form
            e.preventDefault();
            await me.pre(e);
            this.$nextTick(() => {
              me.updateScrollWhenTabPress();
            });
          }
          break;
        //Xử lý F2 giống excel
        case this.$ms.constant.KeyCode.F2:
          const input = e.currentTarget;
          if (input) {
            const {selectionEnd, selectionStart} = input;
            if (selectionEnd - selectionStart === input.value.length) {
              input.selectionEnd = input.value.length;
              input.selectionStart = input.value.length;
            }
          }
          break;
        case this.$ms.constant.KeyCode.Delete:
          if (e.ctrlKey) {
            e.stopPropagation();
            this.shortKeyDeleteRow(me);
          }
          break;
        case this.$ms.constant.KeyCode.Insert:
          if (e.ctrlKey) {
            e.stopPropagation();
            this.shortKeyAddRow(me);
          }
          break;
      }
    },

    /**
     * Tách hàm dùng chung với sự kiện contextMenu
     * NXCHIEN 06.12.2023
     */
    shortKeyDeleteRow(me) {
      const {_currentEditor} = me;
      if (_currentEditor) {
        const {rowIndex} = _currentEditor;
        me.deleteRow(me.dataView[rowIndex]);
      }
    },

    /**
     * Tách hàm dùng chung với sự kiện contextMenu
     * NXCHIEN 06.12.2023
     */
    async shortKeyAddRow(me) {
      const {_currentEditor} = me;
      if (_currentEditor) {
        const {rowIndex, dataRow} = _currentEditor;
        const indexFullData = me.datax.findIndex(x => x === dataRow);
        const passFocus = false;
        // Trường hợp là dòng cuối cùng của trang thì submit grid trước khi sang trang
        if (rowIndex == this.pageSizeInternal - 1) {
          await this.submitEditor();
        }
        me.addRow(indexFullData + 1, rowIndex + 1, passFocus);
      }
    },

    clickCheckBoxByIndex(e, indexOfRowFocused) {
      let me = this;
      if (me.multiple) {
        let trs = me.$el.querySelectorAll('.ms-tbody.data tr');
        if (trs && trs.length > 0) {
          let row = me.$refs[`tr-${me.indexOfRowFocused}`];
          let checkbox = null;
          if (Array.isArray(row)) {
            row = row[0];
          }
          checkbox = row.$refs[`multiple`];
          if (checkbox) {
            checkbox.$el.click();
          }
          e.preventDefault();
        }
      }
    },
    /**
     * Focus vào control cuối cùng
     */
    focusLastControl(event) {
      const me = this;
      me.pre();
    },
    /**
     * Hàm chọn dòng đầu tiên
     * ischeckbox: có tích chọn vào ô checkbox không, mặc định là không và chỉ đơn thuần là click vào dòng đầu tiên
     * created by nnlam 06.03.2021
     * TODO => NCPHUOC 22/04: Xóa tạm các event này, chưa dùng đến
     */
    autoSelectedFirstRow(ischeckbox) {
      let me = this;
      me.$nextTick(() => {
        if (me.datax.length > 0 || me.dataxAllPagin.length > 0) {
          if (ischeckbox) {
            me.rowSelected = me.datax[0] || me.dataxAllPagin[0];
            me.indexOfRowFocused = 0;
          }
          let trFirst = me.$el.querySelector('.ms-tbody.data tr');
          if (trFirst) {
            if (typeof trFirst.getVueInstance == 'function' && trFirst.getVueInstance()) {
              // trFirst.getVueInstance()._events.click;
            }
            // me.$emit('focus', me.datax[0]);
          }
          // me.$emit('firstLoad', me.datax[0]);
        }
      });
    },

    //focus vào editor đầu tiên trong grid
    focusFisrtControl(e) {
      const me = this;
      e.preventDefault();
      me.next();
    },
    /**
     * Start 1 editor mới
     * NCPHUOC 05/04/2022
     */
    async changeEditor(colIndex, rowIndex, col) {
      const me = this;
      if (me.isCellEditor(me.columnx[colIndex], me.dataView[rowIndex])) {
        const newEditor = me.getCellEditor(colIndex, rowIndex);

        //Nếu có editor cũ đang hiện, thực hiện submit editor cũ mới cache lại rowData;
        await me.submitEditor();
        //Xử lý chuyển dòng selected trước khi submitGridEditor
        if (newEditor) {
          if (newEditor.rowIndex != me._oldRowIndex && me._oldRowIndex !== undefined) {
            let data = me.dataView;
            me.rowSelected = data[newEditor.rowIndex];
            me.dataView[newEditor.rowIndex].selected = true;
            if (me.dataView[me._oldRowIndex]) {
              me.dataView[me._oldRowIndex].selected = false;
            }
          } else {
            me.dataView.forEach(item => (item.selected = false));
            let newIndexSelected = newEditor.rowIndex;
            me.dataView[newIndexSelected].selected = true;
          }
        }
        me.$emit('onEditEventCellEditor', colIndex, rowIndex, this, col);
        me._cacheRow = {...me.dataView[rowIndex]};

        if (newEditor && typeof newEditor.activeCell === 'function') {
          me._currentEditor = newEditor;
          await newEditor.activeCell();
        }
        me.$emit('onAfterEditEventCellEditor', colIndex, rowIndex, this, col);
      } else {
        me.$emit('onEditEventCellEditor', colIndex, rowIndex, this, col);
      }

      // Bổ sung thêm toggle event theo thiết kế mới: Submit xong
    },
    /**
     * Tìm colIndex có thể edit trên row
     * NCPHUOC 18/05/2022: columns => columnx
     */
    findValidNextEditorInRow(colIndex, rowIndex) {
      const me = this;
      //Lấy cột edit liền trước tại dòng
      let nextIndex = -1;
      if (colIndex < me.columnx.length - 1) {
        for (let colLoopIndex = colIndex + 1; colLoopIndex < me.columnx.length; colLoopIndex++) {
          if (me.isCellEditor(me.columnx[colLoopIndex], me.datax[rowIndex])) {
            // Lấy dataField của ô hiện tại trong loop
            const dataField = me.columnx[colLoopIndex].dataField;
            // Kiểm tra xem ô hiện tại có thỏa mãn điều kiện skip qua nó
            //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
            if (
              (this.skipDataFieldTab?.hasOwnProperty(dataField) &&
                this.skipDataFieldTab[dataField] == me.columnx[colLoopIndex + 1]?.dataField &&
                me.isCellEditor(me.columnx[colLoopIndex + 1], me.datax[rowIndex])) ||
              (me.isQuickEditVoucher && !me.configVoucherQuickEdit.includes(dataField))
            ) {
              continue;
            } else {
              nextIndex = colLoopIndex;
              break;
            }
          }
        }
      }
      return nextIndex;
    },
    //Chuyển editor sang ô tiếp theo
    async next(e) {
      const me = this,
        {_currentEditor} = me;
      let colIndex = -1,
        rowIndex = 0;
      if (_currentEditor) {
        (colIndex = _currentEditor.colIndex), (rowIndex = _currentEditor.rowIndex);
      }
      //Nếu có custom function check cell thì submit luôn cell để chuẩn hóa value check cell
      if (typeof me.hasEditor === 'function') {
        await me.submitEditor();
      }
      const nextIndex = me.findValidNextEditorInRow(colIndex, rowIndex);
      if (nextIndex !== -1) {
        await me.changeEditor(nextIndex, rowIndex);
      } else {
        //Nếu không có ô nào
        if (rowIndex < me.dataView.length - 1) {
          for (let rowLoopIndex = rowIndex + 1; rowLoopIndex < me.dataView.length; rowLoopIndex++) {
            const lastIndex = me.isQuickEditVoucher
              ? me.columnx.map(x => me.configVoucherQuickEdit.includes(x.dataField)).indexOf(true)
              : me.columnx.map(x => me.isCellEditor(x, me.dataView[rowLoopIndex])).indexOf(true);
            if (lastIndex !== -1) {
              //nếu tìm được ô phù hợp sẽ submit luôn ô hiện tại này để thực hiện các action phía sau
              await me.submitEditor();
              if (me.dataView[rowIndex] && me.dataView[rowIndex].state == me.$ms.constant.ModelState.Empty) {
                this.$ms.commonFn.focusNextControl(me.$refs.inputBottom);
              } else {
                await me.changeEditor(lastIndex, rowLoopIndex);
              }
              break;
            }
          }
        } else {
          //khi đứng ở cell cuối thì bay ra ngoài grid
          await me.submitEditor();
          e.preventDefault();
          this.autoAddRow(rowIndex);
        }
      }

      if (e) {
        e.stopPropagation();
      }
    },
    /**
     * Clone row liền trước
     * NCPHUOC 22/06/2022
     */
    cloneRow(indexView, item) {
      const me = this;
      const preRow = me.dataView[indexView];
      item = Object.assign({...preRow}, item);

      const clearFields = ['state'].concat(
        this.columnx.filter(x => x.columnType === me.$ms.constant.ColumnType.Number).map(x => x.dataField),
      );
      clearFields.forEach(field => delete item[field]);
      return item;
    },

    /**
     * Auto add row khi tab xuống dòng dưới
     * NCPHUOC 22/06/2022
     */
    autoAddRow(rowIndex) {
      const me = this;
      if (this.dataView[rowIndex].state !== this.$ms.constant.ModelState.Empty) {
        const indexFullData = null;
        const indexDataView = this.dataView.length;
        this.addRow(indexFullData, indexDataView);
      } else {
        this.$ms.commonFn.focusNextControl(me.$refs.inputBottom);
      }
    },
    /**
     * Di chuyển editor về trước
     * NCPHUOC 05/04/2022
     */
    async pre(e) {
      const me = this,
        {_currentEditor} = me;
      let colIndex = me.columnx.length,
        rowIndex = me.dataView.length - 1;
      if (_currentEditor) {
        (colIndex = _currentEditor.colIndex), (rowIndex = _currentEditor.rowIndex);
      }
      //Lấy cột edit liền trước tại dòng
      let nextIndex = -1;
      if (colIndex > 0) {
        for (let colLoopIndex = colIndex - 1; colLoopIndex >= 0; colLoopIndex--) {
          //Nếu là sửa nhanh chứng từ
          if (me.isQuickEditVoucher) {
            if (me.configVoucherQuickEdit.includes(me.columnx[colLoopIndex].dataField)) {
              nextIndex = colLoopIndex;
              break;
            }
          } else {
            if (me.isCellEditor(me.columnx[colLoopIndex], me.dataView[rowIndex])) {
              nextIndex = colLoopIndex;
              break;
            }
          }
        }
      }

      if (nextIndex !== -1) {
        await me.changeEditor(nextIndex, rowIndex);
      } else {
        //Nếu không có ô nào
        if (rowIndex > 0) {
          for (let rowLoopIndex = rowIndex - 1; rowLoopIndex >= 0; rowLoopIndex--) {
            const lastIndex = me.isQuickEditVoucher
              ? me.columnx.map(x => me.configVoucherQuickEdit.includes(x.dataField)).lastIndexOf(true)
              : me.columnx.map(x => me.isCellEditor(x, me.dataView[rowLoopIndex])).lastIndexOf(true);
            if (lastIndex !== -1) {
              await me.changeEditor(lastIndex, rowLoopIndex);
              break;
            }
          }
        } else {
          //khi đứng ở cell cuối thì bay ra ngoài grid
          await me.submitEditor();
          e.preventDefault();
          me.$ms.commonFn.focusPreviewControl(me.$refs.inputTop);
        }
      }
      if (e) {
        e.stopPropagation();
      }
    },
    /*
    /**
     * Check xem cell này có được edit hay không
     * NCPHUOC 04/03/2021
     */
    isCellEditor(col, row) {
      if (this.groupField && this.groupField.includes(col.dataField)) {
        return false;
      }
      return col?.editable && (!this.hasEditor || (typeof this.hasEditor === 'function' && this.hasEditor(col, row)));
    },

    /**
     * Lên dòng bằng phím tắt
     * NCPHUOC 20/07/2022
     */
    async upRow() {
      const me = this,
        {_currentEditor} = me;
      let rowIndex = 0,
        colIndex = 0;
      if (_currentEditor) {
        colIndex = _currentEditor.colIndex;
        rowIndex = _currentEditor.rowIndex;
      }
      const length = this.dataView.length;

      if (rowIndex === 0) return;
      for (let index = rowIndex - 1; index >= 0; index--) {
        const element = this.dataView[index];
        if (me.isCellEditor(this.columnx[colIndex], element)) {
          //Nếu có custom function check cell thì submit luôn cell để chuẩn hóa value check cell
          if (typeof me.hasEditor === 'function') {
            await me.submitEditor();
          }
          await me.changeEditor(colIndex, index);
          break;
        }
      }
    },

    /**
     * Xuống dòng bằng phím tắt
     * NCPHUOC 20/07/2022
     */
    async downRow() {
      const me = this,
        {_currentEditor} = me;
      let rowIndex = 0,
        colIndex = 0;
      if (_currentEditor) {
        colIndex = _currentEditor.colIndex;
        rowIndex = _currentEditor.rowIndex;
      }
      const length = this.dataView.length;

      for (let index = rowIndex; index < length; index++) {
        //add thêm dòng nếu dòng hiện tại ko phải dòng trống và đang ở dòng cuối cùng
        if (rowIndex === length - 1) {
          //TODO chỗ này xem xét để có thể giữ được active cell
          await this.submitEditor();

          //Nếu dòng này đã được nhập liệu thì auto add thêm dòng xuống dưới
          if (this.dataView[rowIndex].state !== me.$ms.constant.ModelState.Empty) {
            const index = null;
            const passForcus = false;
            const activeCol = colIndex;
            this.addRow(index, rowIndex + 1, passForcus, activeCol);
            break;
          }
        }
        if (index === rowIndex) continue;

        const element = this.dataView[index];
        if (me.isCellEditor(this.columnx[colIndex], element)) {
          me.changeEditor(colIndex, index);
          break;
        }
      }
    },

    /**
     * Sự kiện dữ liệu được sắp xếp lại
     * Thực hiện lấy index theo dữ liệu gốc để move cho đúng
     * NCPHUOC 05/08/2022
     */
    dataDragChanged({moved}) {
      const me = this;
      const oldRealIndex = me.datax.findIndex(x => x === me.dataView[moved.oldIndex]);

      const newRealIndex = me.datax.findIndex(x => x === me.dataView[moved.newIndex]);

      me.changeDataAfterDrag(oldRealIndex, newRealIndex, true);
    },

    /**
     * Thay đổi dữ liệu sau khi kéo
     * TTLONG 27/02/2023
     */
    async changeDataAfterDrag(oldRealIndex, newRealIndex, dragging) {
      const me = this;
      let isGroup = false;
      //Nếu là grid kéo thả cha con
      if (me.treeDrag) {
        //Nếu đang kéo thì mới check vị trí chuột
        if (dragging) {
          const rowState = me.columnx.filter(el => el.dataField === 'rowState');
          let spaceLeft = {
            value: 0,
          };
          me.$emit('getSpaceLeft', spaceLeft);
          if (event.clientX > rowState[0].width + spaceLeft.value) {
            isGroup = true;
          }
        }
      }

      if (oldRealIndex !== -1 && newRealIndex !== -1) {
        //Nếu là grid kéo thả cha con
        if (me.treeDrag) {
          let indexElementDrop = newRealIndex;
          if (newRealIndex < oldRealIndex && newRealIndex > 0) {
            indexElementDrop--;
          }
          const dataBeforeChange = _.cloneDeep(me.datax);
          const elementDragChild = _.cloneDeep(
            me.datax.filter(e => e[me.fieldRootDrag] === me.datax[oldRealIndex][me.fieldParentDrag]),
          );
          const elementDropChild = _.cloneDeep(
            me.datax.filter(e => e[me.fieldRootDrag] === me.datax[indexElementDrop][me.fieldParentDrag]),
          );
          const newRealIndexOrigin = newRealIndex;
          //kiểm tra phần tử đang kéo là cha và phần tử ở vị trí thả là cha hoặc con thì đẩy phần tử đang kéo xuống dưới cùng cấp với phần tử cha ở vị trí thả
          if (elementDragChild.length > 0 && me.datax[newRealIndex][me.fieldRootDrag]) {
            //lấy index item cha
            const parentIndex = me.datax.findIndex(
              e => e[me.fieldParentDrag] === me.datax[newRealIndex][me.fieldRootDrag],
            );
            const childElement = me.datax.filter(
              e => e[me.fieldRootDrag] === me.datax[parentIndex][me.fieldParentDrag],
            );
            //vị trí chèn = vị trí của cha + số con + 1
            newRealIndex = parentIndex + childElement.length;
            if (oldRealIndex > newRealIndex) {
              newRealIndex++;
            }
          }
          //Nếu phần tử đang kéo là cha và phần tử tại vị trí thả cũng là cha thì đẩy phần tử đang kéo xuống dưới cùng cấp với phần tử cha ở vị trí thả
          else if ((elementDragChild.length > 0 || (!isGroup && dragging)) && elementDropChild.length > 0) {
            //vị trí chèn = vị trí của cha + số con + 1
            newRealIndex = indexElementDrop + elementDropChild.length;
            if (oldRealIndex > newRealIndex) {
              newRealIndex++;
            }
          }
          if (
            !me.lockTreeDrag ||
            !(isGroup || me.datax[indexElementDrop][me.fieldRootDrag] || me.datax[oldRealIndex][me.fieldRootDrag])
          ) {
            await me.datax.move(oldRealIndex, newRealIndex);
            let oldIndexChild = oldRealIndex;
            let newIndexChild = newRealIndex;
            //Đổi chỗ các item con theo item cha
            elementDragChild.forEach(async e => {
              //Nếu kéo lên trên thì vị trí của các item con sẽ bị xô nên cộng thêm 1 thứ tự
              if (oldRealIndex > newRealIndex) {
                oldIndexChild++;
                newIndexChild++;
              }
              await me.datax.move(oldIndexChild, newIndexChild);
            });
            me.$emit(
              'updateChangeDataDrag',
              dataBeforeChange,
              me.datax,
              oldRealIndex,
              newRealIndexOrigin,
              newRealIndex,
              isGroup,
              dragging,
            );
          }
        } else {
          me.$emit('updateChangeDataDrag', me.datax, oldRealIndex, newRealIndex);
          if (!this.customUpdateChangeDragData) {
            me.datax.move(oldRealIndex, newRealIndex);
          } else {
            me.datax.move(oldRealIndex, newRealIndex);
          }
        }
      }
      if (!me.isFiltered) {
        me.datax.forEach((item, index) => {
          item.sort_order = index + (me.dragRow ? 1 : 0);
        });
      } else {
        me.$emit('updateSortOrder', me.datax);
      }

      me.$nextTick(() => {
        me.$emit('updateAfterDrag', me.datax, oldRealIndex, newRealIndex);
      });
      /**
       * emit ra ngoài là thứ tự dữ liệu bị thay đổi
       * NCPHUOC 07/07/2022: Kiểm tra nếu đang filter thì ko update
       */
      if (me.data.length !== me.datax.length) {
        return;
      }
      me.$emit('update:list', me.datax);
    },

    /**
     * Check khi đang kéo chuyển row
     * TTLONG 09/03/2023
     */
    moveRow(e) {
      const me = this;
      if (me.treeDrag) {
        const oldIndex = e.draggedContext.index;
        const newIndex = e.relatedContext.index;

        const elementDragHasChild = me.datax.filter(
          e => e[this.fieldRootDrag] === me.datax[oldIndex][this.fieldParentDrag],
        );
        const elementDropHasChild = me.datax.filter(
          e => e[this.fieldRootDrag] === me.datax[newIndex][this.fieldParentDrag],
        );
        //Nếu kéo thả 1 thằng cha vào 1 thằng cha khác thì hủy bỏ kéo
        // if(elementDragHasChild.length>0 && elementDropHasChild.length>0 ){
        //   return false
        // }
        // //Nếu kéo thả 1 thằng cha vào thằng con thì bỏ kéo
        // if(elementDragHasChild.length>0 && me.datax[newIndex][this.fieldRootDrag] ){
        //   return false
        // }

        const rowState = me.columnx.filter(el => el.dataField === 'rowState');
        //khởi tạo object để reference được thay đổi khi truyền qua emit
        let spaceLeft = {
          value: 0,
        };
        me.$emit('getSpaceLeft', spaceLeft);
        //Nếu kéo cha làm con hoặc kéo 1 row làm con của row con thì hủy
        if (
          event.screenX > rowState[0].width + spaceLeft.value &&
          (elementDragHasChild.length > 0 || me.datax[newIndex][this.fieldRootDrag])
        ) {
          return false;
        }
      }
    },
    /**
     * Start edit 1 row mới
     * NCPHUOC 21/07/202: Thêm cột mặc định sẽ active vào khi thêm edit row
     */
    startEditRow(rowIndex, activeCol = null) {
      const me = this;
      const startCol = -1;
      const colIndex =
        activeCol === null || activeCol === undefined ? me.findValidNextEditorInRow(startCol, rowIndex) : activeCol;
      me.changeEditor(colIndex, rowIndex);
    },

    /**
     * Hàm thực hiện việc sort trên grid
     * @params col cột được thực hiện sắp sếp
     * @params mode gồm null,DESC,ASC
     * created by LTDAT
     */
    sort(col, mode) {
      const me = this;
      if (me.data && me.data.length > 0) {
        let data = [...me.data];

        //hàm sort
        // function compare(a, b) {
        //   if (a[col.dataField] < b[col.dataField]) return mode == me.$ms.constant.SortStatus.desc ? 1 : -1;
        //   if (a[col.dataField] > b[col.dataField]) return mode == me.$ms.constant.SortStatus.asc ? 1 : -1;
        //   return 0;
        // }
        //thực hiện sort
        if (mode != me.$ms.constant.SortStatus.none) {
          //Hiện tại đọc code đang sort theo trường cuối cùng nên chỉ cache lại 1 trường
          me.cacheSort = [{sortField: col.dataField, sortType: mode}];
          data = commonFn.sortArray(data, me.cacheSort);
        } else {
          me.cacheSort = [];
        }

        if (!me.pagination) {
          me.datax = data;
        }

        // Gán lại sort_order
        if (me.recalculateSortOrder) {
          let sortOrder = 0;
          if (me.datax && Array.isArray(me.datax)) {
            me.datax.forEach(item => {
              item.sort_order = sortOrder;
              sortOrder += me.stepSortOrder;
            });
          }
        }
      }
    },
    /**
     * Hàm thực hiện việc sort trên grid
     * created by NXCHIEN 13.05.2022
     */
    async deleteAllRow() {
      const me = this;
      if (me.deleteAllRowCustom) {
        if (me.disabled) {
          return;
        }
        let configMessage = me.getDeleteConfirmMessage(true, null);

        if (configMessage) {
          showConfirm(configMessage).then(answer => {
            if (answer) {
              this.handleDeleteAllRow();
            }
          });
        }
      } else {
        await this.handleDeleteAllRow();
      }
    },

    async handleDeleteAllRow() {
      const me = this;

      if (me.disabled) {
        return;
      }
      await this.submitEditor();
      let data = me.pagination ? me.dataViewAllPagin : me.dataView;
      for (let index = data.length - 1; index >= 0; index--) {
        let rowData = data[index];
        if (rowData.isDataView) {
          continue;
        }
        if (rowData.state === me.$ms.constant.ModelState.Empty || rowData.state === me.$ms.constant.ModelState.Insert) {
          const index = me.pagination
            ? me.dataxAllPagin.findIndex(x => x === rowData)
            : me.datax.findIndex(x => x === rowData);
          if (index !== -1) {
            if (me.pagination) {
              me.dataxAllPagin.splice(index, 1);
            } else {
              me.datax.splice(index, 1);
            }
          }
        } else {
          rowData.state = me.$ms.constant.ModelState.Delete;
        }
      }

      me.$emit('update:modelValue', []);

      // Thêm 1 dòng trống
      if (this.showRowEmpty) {
        me.addRow(0, 0);
      }

      this.$emit('afterDeleteRow', [...data], true, this); // false là xóa 1 dòng, true là xóa hết
    },

    /**
     * lưu tất cả các cột đã đánh dấu là đang filter
     */
    buildFilterHeader(col) {
      let me = this;
      let check = me.filterHeader.filter(i => i.dataField == col.dataField);
      if (check.length == 0) {
        me.filterHeader.push(col);
      } else {
        me.filterHeader.forEach(item => {
          if (item.dataField == col.dataField) {
            item = col;
            return;
          }
        });
      }
      let th = me.$refs.th.filter(x => x.col.dataField == col.dataField);
      if (th && th.length > 0) {
        th[0].checkHideMenuHeader();
      }
    },

    /**
     * hàm xóa 1 item filter
     */
    removeFilterItem(item) {
      let me = this;
      me.filterHeader.remove(item);
      if (
        !item.formatType ||
        item.formatType == me.$ms.constant.FormatType.Text ||
        item.formatType == me.$ms.constant.FormatType.None
      ) {
        item.filter.operator = me.$ms.constant.FilterHeader.Contains;
      } else {
        item.filter.operator = me.$ms.constant.FilterHeader.Equals;
      }
      item.filter.value = null;
      item.hasActionFilter = false;
      let th = me.$refs.th.filter(x => x.col.dataField == item.dataField);
      if (th && th.length > 0) {
        th[0].checkHideMenuHeader();
      }
      me.$emit('filter', item);
    },

    /**
     * Đọc điều kiện filter header
     */
    getFilterHeader(hasColumn) {
      let me = this,
        result = [],
        enumFilterHeader = me.$ms.constant.FilterHeader,
        columns = me.filterHeader; //me.columnx;

      for (let i = 0; i < columns.length; i++) {
        let column = columns[i];
        if (column.filter && column.filter.value !== column.filterIgnoreValue) {
          let item = null,
            filterValue = column.filter.value,
            operator = column.filter.operator;
          switch (operator) {
            case enumFilterHeader.Between:
              item = {
                property: column.dataField,
                operator: me.$ms.constant.FilterHeader.GreaterThanEquals,
                value: column.filter.from,
                operand: 'and',
                childrens: [
                  {
                    property: column.dataField,
                    operator: me.$ms.constant.FilterHeader.LessThanEquals,
                    value: column.filter.to,
                    operand: 'and',
                  },
                ],
              };
              break;
            case enumFilterHeader.Null:
            case enumFilterHeader.NotNull:
              item = {
                property: column.dataField,
                operator: operator,
                operand: 'and',
              };

              //với cột text sẽ fix giá trị để lên server sẽ xử lý thêm kiểm tra với giá trị trống ''
              switch (column.columnType) {
                case 'ColumnText':
                case 'ColumnDrilldown':
                  item.value = 'text';
                  break;
              }
              break;
            case enumFilterHeader.Contains:
            case enumFilterHeader.Notcontains:
            case enumFilterHeader.StartsWith:
            case enumFilterHeader.EndsWith:
              if (typeof filterValue !== 'undefined' && filterValue !== null && filterValue !== '') {
                // let words = me.$ms.commonFn.splitKeyWord(filterValue);
                // var addColumnFilter = function(filter) {
                //   if (!item) {
                //     item = filter;
                //     item.childrens = [];
                //   } else {
                //     if (
                //       operator === enumFilterHeader.StartsWith ||
                //       operator === enumFilterHeader.EndsWith
                //     ) {
                //       item.operand = "or";
                //     } else {
                //       item.operand = "and";
                //     }
                //     item.childrens.push(filter);
                //   }
                // };
                // if (words.length > 0) {
                //   for (let i = 0; i < words.length; ++i) {
                //     let filterItem = {
                //       property: column.dataField,
                //       value: words[i],
                //       operator: operator,
                //       operand:
                //         operator === enumFilterHeader.StartsWith ||
                //         operator === enumFilterHeader.EndsWith
                //           ? "or"
                //           : "and"
                //     };
                //     addColumnFilter(filterItem);
                //   }
                // }
                item = {
                  property: column.dataField,
                  operator: operator,
                  value: filterValue,
                  operand: 'and',
                };
              }
              break;
            default:
              switch (column.columnType) {
                case 'ColumnDateTime':
                  if (filterValue) {
                    item = {
                      property: column.dataField,
                      value: filterValue, //moment(filterValue).format('YYYY-MM-DD'),
                      operator: operator,
                      operand: 'and',
                    };
                  }
                  break;
                default:
                  if (typeof filterValue !== 'undefined' && filterValue !== null && filterValue !== '') {
                    item = {
                      property: column.dataField,
                      value: filterValue,
                      operator: operator,
                      operand: 'and',
                    };
                  }
                  break;
              }
              break;
          }

          //xử lý tình huống enum của cột không chứa giá trị thì khỏi filter
          if (item && column.enumName) {
            let enumObj = me.$ms.enum[column.enumName || column.enum],
              hasValue = false;
            for (let i in enumObj) {
              if (enumObj[i] === item.value) {
                hasValue = true;
                break;
              }
            }

            if (!hasValue) {
              item = null;
            }
          }

          if (item) {
            if (hasColumn) {
              item.column = column;
            }
            if (column.nullToFail) {
              item.nullToFail = column.nullToFail;
            }

            result.push(item);
          }
        }
      }

      return result;
    },

    /**
     * hàm conver toán tử thành text: ví dụ "Contants" -> "Chứa"
     */
    buildOperatorText(operator) {
      let operatorText = this.$ms.commonFn.getEnumResource(operator, 'FilterHeader');
      if (operatorText) {
        operatorText = operatorText.toLocaleLowerCase();
      }
      return operatorText;
    },

    /**
     * hàm xóa 1 item filter
     */
    removeFilterItem(item) {
      let me = this;
      me.filterHeader.remove(item);
      if (
        !item.formatType ||
        item.formatType == me.$ms.constant.FormatType.Text ||
        item.formatType == me.$ms.constant.FormatType.None
      ) {
        item.filter.operator = me.$ms.constant.FilterHeader.Contains;
      } else {
        item.filter.operator = me.$ms.constant.FilterHeader.Equals;
      }
      item.filter.value = null;
      item.hasActionFilter = false;
      let th = me.$refs.th.filter(x => x.col.dataField == item.dataField);
      if (th && th.length > 0) {
        th[0].checkHideMenuHeader();
      }
      me.$emit('filter', item);
    },
    /**
     * hàm bỏ lọc
     * modifiedBy dtnga3 (11.04.2024) chuyển sang hàm removeFilter để xóa cả text filter trên header vì hàm checkHideMenuHeader k được khai báo ở đâu cả
     */
    clearAllFilter() {
      let me = this;
      //me.filterHeader.removeAll();
      me.filterHeader.forEach(item => {
        if (
          !item.formatType ||
          item.formatType == me.$ms.constant.FormatType.Text ||
          item.formatType == me.$ms.constant.FormatType.None
        ) {
          item.filter.operator = me.$ms.constant.FilterHeader.Contains;
        } else {
          item.filter.operator = me.$ms.constant.FilterHeader.Equals;
        }
        item.filter.value = null;
        item.hasActionFilter = false;
        let th = me.$refs.th.filter(x => x.col.dataField == item.dataField);
        if (th && th.length > 0) {
          th[0].removeFilter();
        }
      });
      me.$emit('filter', {});
      me.filterHeader = [];
    },

    /**
     * hàm build value filter
     */
    buildValue(item) {
      if (
        item.filter &&
        (item.filter.operator == this.$ms.constant.FilterHeader.Null ||
          item.filter.operator == this.$ms.constant.FilterHeader.NotNull)
      ) {
        return '';
      }
      if (item.filter.value == 0) {
        return '0';
      }
      let value = this.$ms.format.formatData(item.filter.value, {
        formatType: item.formatType,
        enumName: item.enum,
        dataRow: {},
      });
      return '"' + value + '"';
    },

    changePageSize(value) {
      let me = this;
      if (me.pagination) {
        this.pageSizeInternal = value;
      }
      this.$emit('changePageSize', value);
    },

    customPreOrNextPage(data) {
      this.$emit('customPreOrNextPage', data);
    },

    async listenersLoadData(payload) {
      const me = this;
      await me.submitEditor();
      if (me.pagination) {
        // cache lại dữ liệu lỗi ở trang trước
        me.cacheValidatePagin();
        me.currentPage = payload.skip / payload.take + 1;
      }
      me.$refs.content.scrollTop = 0;
    },

    getItemPagination() {
      let me = this,
        pageSize = me.getPageSize(),
        min = Math.ceil((me.currentPage - 1) * pageSize),
        max = min + pageSize;
      // phân trang theo filter
      let dataFilter = [...me.dataViewAllPagin];
      // sắp xếp dữ liệu khi sort trên header
      if (me.cacheSort) {
        dataFilter = commonFn.sortArray(dataFilter, me.cacheSort);
      }
      dataFilter = dataFilter ? dataFilter : [];
      let dataPagination = dataFilter.filter((item, index) => {
        return index >= min && index < max;
      });
      return dataPagination;
    },
    /**
     * Thêm dòng
     * Nếu không có index sẽ mặc định push xuống cuối
     * @param
     */
    addRow(index, indexView, passForcus, activeCol) {
      let me = this;
      let item = {
        [me.idField]: commonFn.generateUUID(),
        state: me.$ms.constant.ModelState.Empty,
      };

      //Nếu có cấu hình group sẽ auto copy row
      if (this.groupField) {
        item = {...me.datax[index - 1], ...item, ...{indexRow: indexView}};
      }

      if (!me.columnx.find(x => x.dataField == 'rowAction') || !me.hasAddRow) {
        //tab sang control tiếp theo khi focus vào ô cuối cùng của grid
        this.$ms.commonFn.focusNextControl(me.$refs.inputBottom);
        return;
      }
      //Xử lý trước khi add row nếu có
      if (typeof me.beforeAddRow == 'function') {
          let res = me.beforeAddRow(me.dataView[indexView - 1], indexView, me);
          if(res == false)
          {
            return;
          }
      }

      if (typeof me.initDataBeforeAddRow == 'function') {
        item = me.initDataBeforeAddRow(me.dataView[indexView - 1], indexView, me);
      } else if (me.initDataBeforeAddRow) {
        item = {...item, ...me.initDataBeforeAddRow};
      }

      // nếu dòng đang được selected là dòng cuối cùng thì bỏ select dòng đấy đi
      // hàm changeEditor không bỏ selecte được dòng này vì lúc chạy đến hàm changeEditor thì dòng này ở trang tiếp theo rồi
      if (me.dataView?.length && me.dataView[me.pageSizeInternal - 1]?.selected && indexView != me.pageSizeInternal) {
        me.dataView[me.pageSizeInternal - 1].selected = false;
      }

      if (index) {
        me.pagination ? me.dataxAllPagin.insertAt(index, item) : me.datax.insertAt(index, item);
      } else {
        me.pagination ? me.dataxAllPagin.push(item) : me.datax.push(item);
      }
      this.updateDataBinding();

      // trường hợp là dòng cuối cùng thì sang trang
      if (indexView == me.pageSizeInternal && me.pagination) {
        indexView = 0;
        me.currentPage += 1;

        // bỏ tất cả selected ở trang tiếp theo nếu sang trang
        me.dataView?.forEach(x => (x.selected = false));
      }
      me.$nextTick(() => {
        //sau khi thêm dòng thì autofocus vào editor đầu tiên của dòng đó
        !passForcus && me.startEditRow(indexView != undefined ? indexView : me.dataView.length - 1, activeCol);
        //Scroll đến dòng cuối nếu click vào dòng cuối cùng
        if (indexView != undefined && indexView == me.dataView.length - 1) {
          me.scrollToNextEl(me, true);
        } else {
          me.scrollToNextEl(me, false, indexView);
        }
      });
    },

    scrollToNextEl: function (me, scrollToEnd, itemIndex) {
      // kiểm tra xem có scroll hay không thì Scroll xuống cuối
      me.checkHasScroll();
      if (me.hasScroll) {
        const content = me.$refs.content;
        if (scrollToEnd) {
          content.scrollTop = content.scrollHeight;
        } else {
          var tr = me.$el.getElementsByClassName('ms-tr')[1];
          var scrollToPosition = (itemIndex - 1) * tr.offsetHeight;
          content.scrollTop = scrollToPosition;
        }
      }
    },
    /**
     * Duplicate thêm dòng
     * NCPHUOC 14/04/2022
     */
    duplicateRow(rowData, rowIndex) {
      const copyRow = {...rowData};
      copyRow[this.idField] = commonFn.generateUUID();
      copyRow.state = this.$ms.constant.ModelState.Empty;
      this.datax.insetAt(rowIndex + 1, copyRow);

      me.$nextTick(() => {
        me.startEditRow(rowIndex + 1);
      });
      this.updateDataBinding();
    },

    /**
     * Xóa dòng
     * NCPHUOC 14/04/20202
     * Modified: NXCHIEN 13.04.2022: Sửa TH xóa dữ liệu còn 1 dòng
     * Modified: TVDAT 17/05/2023 Thêm param bỏ focus
     */
    deleteRow(rowData, passForcus) {
      const me = this;
      let indexDelete = 0;
      // clear cacheRow
      if (me._cacheRow && rowData[me.idField] == me._cacheRow[me.idField]) {
        delete me._cacheRow;
      }

      let data = this.dataView.filter(x => !x.isDataView)?.length;
      if (data === 1 && rowData.state === this.$ms.constant.ModelState.Empty) return;

      if (
        rowData.state === this.$ms.constant.ModelState.Empty ||
        rowData.state === this.$ms.constant.ModelState.Insert
      ) {
        let index = me.pagination
          ? me.dataxAllPagin.findIndex(x => x === rowData)
          : this.datax.findIndex(x => x === rowData);
        if (index !== -1) {
          me.pagination ? this.dataxAllPagin.splice(index, 1) : this.datax.splice(index, 1);
          data > 1 && this.updateDataBinding();
          indexDelete = index;
        }
      } else {
        rowData.state = this.$ms.constant.ModelState.Delete;
      }

      if (
        data === 1 &&
        (rowData.state === this.$ms.constant.ModelState.Delete || rowData.state === this.$ms.constant.ModelState.Insert)
      ) {
        // Thêm 1 dòng trống
        if (this.showRowEmpty) {
          this.addRow(this.datax.length, 0);
        }
      }
      me.modelValue.remove(rowData);
      me.effectSelected();
      this.$emit('afterDeleteRow', rowData, false, this); // false là xóa 1 dòng, true là xóa hết
      me.$nextTick(() => {
        // Kiểm tra dữ liệu khi xoá để thay đổi dòng focus
        if (indexDelete != me.dataView.length) {
          if (me.dataView[indexDelete] && me.dataView[indexDelete].state == this.$ms.constant.ModelState.Empty) {
            indexDelete = indexDelete - 1 < 0 ? 0 : indexDelete - 1;
          }
        }
        !passForcus && me.startEditRow(indexDelete == me.dataView.length ? indexDelete - 1 : indexDelete);
      });
    },

    getPageSize() {
      return this.pageSizeInternal || 10;
    },
    /**
     * Xóa dòng custom thông báo
     * HQMINH 15.09.2022
     */
    deleteRowCustom(rowData) {
      const me = this;

      if (rowData) {
        let configMessage = me.getDeleteConfirmMessage(false, rowData);
        if (configMessage && (rowData.detail_ref_no || rowData.state != 4)) {
          showConfirm(configMessage).then(answer => {
            if (answer) {
              this.deleteRow(rowData);
            }
          });
        }
      }
    },

    /**
     * Build thông báo cho xóa custom
     * HQMINH 15.09.2022
     * Modified TPNAM 10.02.2025 - escape các ký tự đặc biệt chống tấn công XSS
     */
    getDeleteConfirmMessage(isDeleteAll, record) {
      const me = this;

      let mes = {
        message: '',
        title: 'Loại bỏ chứng từ',
        width: null,
        textBtn: 'Loại bỏ',
      };

      if (isDeleteAll) {
        mes.message = 'Bạn có muốn loại bỏ những chứng từ này không?';
      } else {
        const ref_no = record.detail_ref_no ? record.detail_ref_no : '';

        mes.message = 'Bạn có muốn loại bỏ chứng từ <span style="color: #0eac13;">{0}</span> không?'.format(_.escape(ref_no));
      }
      // emit ra sự kiện để thay đổi lại câu thông báo tvhien - 15.12.2022
      me.$emit('changeMessageConfirm', mes, isDeleteAll, record);

      return mes;
    },

    /**
     * Update vào selected
     * NCPHUOC 01/08/2022
     */
    effectSelected() {
      const me = this;
      me.$emit('update:modelValue', me.modelValue);
    },
    /**
     * Update binding 2 chiều cho danh sách grid khi có effect ở trong mảng
     * NCPHUOC 20/04/2022
     */
    updateDataBinding() {
      if (this.pagination) {
        // nếu phân trang thì emit cả data source
        this.$emit('update:list', this.dataxAllPagin);
      } else {
        this.$emit('update:list', this.datax);
      }
    },
    /**
     * Lấy style footer
     */
    getFooterStyle(col) {
      let res = {};
      if (typeof col.stickyOffset === 'number') {
        res.left = col.stickyOffset + 'px';
      }

      if (typeof col.width === 'number' && this.addWidthBorderFooter) {
        res.minWidth = res.width = col.width + 1 + 'px';
      } else {
        res.minWidth = res.width = col.width + 'px';
      }

      return res;
    },
    /**
     * Sự kiện window resize
     */
    windowResize() {
      const me = this;

      //tính toán xem có scroll ngang không
      me.updateHasScrollX();

      //cập nhật footer
      if (me.footer) {
        me.updateFooterContainer();
        me.initFooterColumn(me.columnx);
      }
    },
    /**
     * Click vào thêm mới dòng
     */
    emptyClick() {
      this.addRow();
    },

    /**
     * Thực hiện validate grid editor
     * NCPHUOC 21/04/2022
     */
    validate(hasValidateSave, triggerDisplayError, customColumnsValidate) {
      const me = this;
      if (me.pagination) {
        return me.validateAllPagin();
      }
      const colHasRules = me.columnx
        .map((item, index) => {
          if (item.rules && item.rules.length > 0) {
            return index;
          }
          return -1;
        })
        .filter(x => x !== -1);
      let message = '';
      if (colHasRules.some(x => x >= 0)) {
        //Lấy ra đúng index và các dòng không phải dòng trống
        const rowsValidate = this.dataView
          .map((x, i) => {
            return {index: i, state: x.state};
          })
          .filter(x => x.state !== this.$ms.constant.ModelState.Empty);

        //Duyệt dòng cột
        colHasRules.forEach(colIndex => {
          rowsValidate.forEach(row => {
            //Lấy ra editor của cell
            const editor = me.getCellEditor(colIndex, row.index);
            if (
              editor &&
              typeof editor.validate === 'function' &&
              (!customColumnsValidate || customColumnsValidate.includes(editor.col?.dataField))
            ) {
              const messageValidateCell = editor.validate(hasValidateSave, triggerDisplayError);
              if (!message) {
                message = messageValidateCell;
              }
              // validate dvc
              else if (this.isValidateDvc && this.multipleErrorField && messageValidateCell) {
                message += `;;${messageValidateCell}`;
              }
              else if (this.multipleErrorField && messageValidateCell && !message.includes(editor.col?.caption)) {
                message += `;${messageValidateCell}`;
              }
            } else if (editor && typeof editor.clearValidate === 'function') {
              editor.clearValidate();
            }
          });
        });
      }

      return message;
    },
    /**
     * Hàm validate tất cả dữ liệu khi grid phân trang
     * Created by NNKiem 21.06.2022
     * Modified by NVTUAN1 27.07.2023: Xử lý lại validate trả về mảng các object để phân biệt giữa các loại validate trên grid => Có câu cảnh báo phù hợp (bug 363214)
     */
    validateAllPagin() {
      let me = this;
       me.cacheValidatePaging = {};
      me.clearFilter();
      var validateValue = function (rules, value, data, caption, col) {
        //Kết quả validate cột trả về
        let validateCol = {
          caption: '', //tên cột validate
          ruleName: '', //tên rule validate
          message: '', //nội dung validate
        };
        for (let i = 0; i < rules.length; i++) {
          const {name, compareValue, customValidate} = rules[i];

          //Xác định tên rule validate
          validateCol.ruleName = name;

          //Xác định tên cột validate
          validateCol.caption = caption;

          //Xác định câu cảnh báo
          if (typeof customValidate == 'function') {
            validateCol.message = customValidate(value, compareValue, caption, data, col);
          } else {
            switch (name) {
              case 'required':
                if (value === undefined || value === null || value === NaN || value === '') {
                  validateCol.message = i18nValidate.messages[name](caption, true);
                }
                break;
              case 'lessThanAmount':
                if (
                  value !== undefined &&
                  value !== null &&
                  !isNaN(value) &&
                  compareValue !== undefined &&
                  compareValue !== null &&
                  !isNaN(compareValue)
                ) {
                  if (parseInt(value) > 0) {
                    if (parseInt(value) >= parseInt(compareValue)) {
                      validateCol.message = i18nValidate.messages[name](caption);
                    }
                  } else {
                    if (parseInt(value) <= parseInt(compareValue) * -1) {
                      validateCol.message = i18nValidate.messages[name](caption);
                    }
                  }
                }
                break;
              case 'pattern':
                if (!validateText.validateRule(compareValue, value)) {
                  validateCol.message = i18nValidate.messages['email'](caption);
                }
                break;
              case 'diffierentZero':
                if (!validateNumber.validatediffierentZero(value)) {
                  validateCol.message = i18nValidate.messages['diffierentZero'](caption);
                }
                break;
              case 'greaterThanZero':
                if (!validateNumber.validategreaterThanZero(value)) {
                  validateCol.message = i18nValidate.messages['greaterThanZero'](caption);
                }
                break;
              case 'missingValue':
              case 'equals':
              case 'moreThan':
              case 'lessThan':
                break;
              default:
                break;
            }
          }

          if (validateCol && validateCol.message) {
            return validateCol;
          }
        }

        return validateCol;
      };
      const colHasRules = me.columnx.filter(x => x?.rules?.length);
      const rowsValidate = this.dataViewAllPagin
        .map((x, i) => {
          return {indexPagin: i, ...x};
        })
        .filter(x => x.state !== this.$ms.constant.ModelState.Empty);
      //Kết quả validate tất cả grid trả về
      let validateGrids = [];
      // vị trí lỗi đầu tiên để next trang;
      let firstIndexInvalid = -1;
      let firstPageInvalid = 1;
      for (let r = 0; r < rowsValidate.length; r++) {
        for (let c = 0; c < colHasRules.length; c++) {
          let column = colHasRules[c],
            rules = column.rules,
            value = rowsValidate[r][column.dataField];
          let result = validateValue(rules, value, rowsValidate[r], column.caption, column);
          if (result && result.message) {
            let valueKey = rowsValidate[r][me.idField];
            if (me.cacheValidatePaging[valueKey]) {
              me.cacheValidatePaging[valueKey][column.dataField] = result.message;
            } else {
              me.cacheValidatePaging[valueKey] = {};
              me.cacheValidatePaging[valueKey][column.dataField] = result.message;
            }
            if (firstIndexInvalid == -1) {
              firstIndexInvalid = rowsValidate[r].indexPagin;
            }

            //Nếu có config multipleErrorField trên grid thì trả về kết quả dạng [{ruleName: 'tên rule 1', message: 'nội dung 1'}, {ruleName: 'tên rule 2', message: 'nội dung 2'}, ...]
            if (this.multipleErrorField) {
              //Chưa có thì mới thêm vào mảng trả về
              if (!validateGrids.find(x => x.caption === result.caption && x.ruleName === result.ruleName)) {
                validateGrids.push(result);
              }
            }
            //Ngược lại trả về kết quả dạng mảng các message ['nội dung 1', 'nội dung 2', ...]
            else {
              validateGrids.push(result.message);
            }
          }
        }
      }
      if (firstIndexInvalid !== -1) {
        let pageSize = me.getPageSize();
        firstPageInvalid = Math.floor(firstIndexInvalid / pageSize) + 1;
        if (firstPageInvalid == me.currentPage) {
          me.$nextTick(() => {
            me.loadCacheValidatePagin(true);
          });
        } else {
          me.$refs.pagination.loadPageIndex(firstPageInvalid);
        }
      }
      return validateGrids;
    },

    /**
     * Load lại validate từ cache khi chuyển trang
     * Created by NNkiem 21/06.2023
     * Modified by NXCHIEN 17.11.2023: active vào ô lỗi đầu tiên
     */
    loadCacheValidatePagin(isActiveError) {
      let me = this;
      let isFirst = true;
      const colHasRules = me.columnx
        .map((col, index) => {
          return {indexColumnx: index, ...col};
        })
        .filter(x => x?.rules?.length);
      const rowsValidate = this.dataView
        .map((x, i) => {
          return {indexRow: i, ...x};
        })
        .filter(x => x.state !== this.$ms.constant.ModelState.Empty);
      //Duyệt dòng cột
      colHasRules.forEach(col => {
        rowsValidate.forEach(row => {
          //Lấy ra editor của cell
          const editor = me.getCellEditor(col.indexColumnx, row.indexRow);
          const valueId = row[me.idField];
          if (me.cacheValidatePaging[valueId]?.[col.dataField] && editor) {
            editor.errorMessage = me.cacheValidatePaging[valueId][col.dataField];
            if (isFirst && isActiveError) {
              // focus
              me.changeEditor(col.indexColumnx, row.indexRow);
              isFirst = false;
            }
          }
        });
      });
    },

    /**
     * Cache lại validate trước khi next trang khác
     * reated by NNkiem 21/06.2023
     * Modified: HMDUC2 17/07/2024 Sửa lỗi không focus row bị validate khi đang ở page khác Bug-449908
     */
    cacheValidatePagin() {
      let me = this;
      const colHasRules = me.columnx
        .map((col, index) => {
          return {indexColumnx: index, ...col};
        })
        .filter(x => x?.rules?.length);
      const rowsValidate = this.getItemPagination()
        .map((x, i) => {
          return {indexRow: i, ...x};
        })
        .filter(x => x.state !== this.$ms.constant.ModelState.Empty);
      //Duyệt dòng cột
      rowsValidate.forEach(row => {
        const valueId = row[me.idField];
        // HMDUC2 17/07/2024: Nếu row đã cacheValidate thì không gán lại rỗng nữa để không mất validate trước đó ở func validateAllPagin()
        if(!me.cacheValidatePaging[valueId]) {
          me.cacheValidatePaging[valueId] = {};
        }
        colHasRules.forEach(col => {
          const editor = me.getCellEditor(col.indexColumnx, row.indexRow);
          if (editor?.errorMessage) {
          
           me.cacheValidatePaging[valueId][col.dataField] = editor.errorMessage;
          }
        });
      });
    },

    /**
     * Xử lý shortkey action
     * HQMINH 22.08.2022
     */
    eventShortkeyAction(e, col, colIndex) {
      const me = this;
      //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
      let hasFunc = me.propsData.shortkey?.hasOwnProperty(col.dataField);
      hasFunc && Function.exec(me.propsData.shortkey[col.dataField], [e, col, colIndex]);
    },

    /**
     * Thực hiện sao chép số liệu dòng hạch toán
     * dtnga3 (23.05.2023)
     * Modified DTQUOC 20.10.2023
     */
    async copyActionClick(actionId, rowIndex, colIndex) {
      // Nếu click vào sao chép dữ liệu --> hiển thị popup sao chép dữ liệu
      const me = this;
      if (actionId == this.$ms.constant.EditorAction.CopyRow) {
        popupUtil.show('CopyValueDetail', {
          sendData: (copyOption, rowNumber) => {
            const column = me.columnx[colIndex];
            const editor = this.getCellEditor(colIndex, rowIndex);
            const value = editor.getValue();
            let objAssign = {[column.dataField]: value};
            let dataView = _.cloneDeep(me.dataView);

            let lastItem = dataView
              .reverse()
              .find(x => x.state !== me.$ms.constant.ModelState.Empty && x.state !== me.$ms.constant.ModelState.Delete);
            let lastIndexView = me.dataView.indexOf(
              me.dataView.find(x => lastItem && x[me.idField] == lastItem[me.idField]),
            );
            let lastIndex = 0;

            // Nếu là copy lên
            if (copyOption == this.$ms.constant.EditorAction.CopyUpRow) {
              lastIndex = rowIndex;
              rowIndex = lastIndex - rowNumber;
              if (rowIndex < 0) {
                rowIndex = 0;
              }
            }

            // Nếu là copy xuống
            if (copyOption == this.$ms.constant.EditorAction.CopyDownRow) {
              lastIndex = rowIndex + rowNumber;

              if (lastIndex > lastIndexView) {
                lastIndex = lastIndexView;
              }
            }

            // Nếu là copy tất cả
            if (copyOption == this.$ms.constant.EditorAction.CopyRow) {
              lastIndex = lastIndexView + 1;
            }
            if (
              column.columnType === me.$ms.constant.ColumnType.Combobox ||
              column.columnType === me.$ms.constant.ColumnType.Enum
            ) {
              // Biến check xem metaData lấy từ xổ combo hay lấy từ dòng dữ liệu
              let isShowCombo = true;

              let metaData = editor.getMetaData();

              // xóa các trường không cần thiết(để chuyển qua được JSON)
              //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
              if (metaData.hasOwnProperty('childNodes')) {
                delete metaData.childNodes;
              }
              //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
              if (metaData.hasOwnProperty('parentNode')) {
                delete metaData.parentNode;
              }

              //Th chưa chọn gì combo
              // Nếu là copy lên trên thì dùng lastIndex mới có dữ liệu tại bên trên gán lại rowIndex ròi
              if (JSON.stringify(metaData) === '{}') {
                metaData = me.dataView[copyOption == this.$ms.constant.EditorAction.CopyUpRow ? lastIndex : rowIndex];
                isShowCombo = false;
              }

              if (lastIndexView !== -1) {
                //Emit ra ngoài các form tự xử lý trường hợp là combo
                // cập nhật dữ liệu vào các trường thông tin liên quan (vd dataField của cột là budgetSourceCode thì cần cập nhật thêm name, id, ...)
                this.$emit(
                  'copyActionClick',
                  copyOption,
                  objAssign,
                  metaData,
                  column,
                  me,
                  lastIndex,
                  rowIndex,
                  isShowCombo,
                  me.updateRowBusiness.bind(me),
                );
              }
            } else {
              let metaData = me.dataView[rowIndex];
              if (lastIndexView !== -1) {
                // cập nhật dữ liệu vào các trường thông tin liên quan (vd dataField của cột là budgetSourceCode thì cần cập nhật thêm name, id, ...)
                this.$emit(
                  'copyActionClick',
                  copyOption,
                  objAssign,
                  metaData,
                  column,
                  me,
                  lastIndex,
                  rowIndex,
                  false,
                  me.updateRowBusiness.bind(me),
                );
              }
            }
            if (objAssign) {
              if (lastIndexView !== -1) {
                let startIndex = rowIndex + 1;
                let endIndex = lastIndex;
                if (copyOption == this.$ms.constant.EditorAction.CopyUpRow) {
                  startIndex = rowIndex;
                  endIndex = lastIndex;
                }
                if (copyOption == this.$ms.constant.EditorAction.CopyRow) {
                  startIndex = 0;
                  endIndex = lastIndex - 1;
                }
                // cập nhật dữ liệu vào các dòng (tại dataField của cột)
                for (let index = startIndex; index <= endIndex; index++) {
                  const element = me.dataView[index];
                  for (const key in objAssign) {
                    //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
                    if (Object.hasOwnProperty.call(objAssign, key)) {
                      const val = objAssign[key];
                      element[key] = val;
                    }
                  }
                  commonFn.changeStateRow(element);
                }
              }
            }
          },
        });
      }

      // const me = this;
      // if (me.isCopyDataColumn) {
      //   if (
      //     (actionId == this.$ms.constant.EditorAction.CopyUpRow && rowIndex > 0) ||
      //     (actionId == this.$ms.constant.EditorAction.CopyDownRow && rowIndex < me.dataView.length - 1)
      //   ) {
      //     const column = me.columnx[colIndex];
      //     const editor = this.getCellEditor(colIndex, rowIndex);
      //     const value = editor.getValue();
      //     let objAssign = {[column.dataField]: value};
      //     // dtnga3 (20.06.2023) đoạn lấy lastIndexView thay cho hàm findLastIndex vì hàm này k hỗ trợ trên FireFox và Microsoft Edge
      //     let dataView = _.cloneDeep(me.dataView);
      //     let lastItem = dataView
      //       .reverse()
      //       .find(x => x.state !== me.$ms.constant.ModelState.Empty && x.state !== me.$ms.constant.ModelState.Delete);
      //     let lastIndexView = me.dataView.indexOf(
      //       me.dataView.find(x => lastItem && x[me.idField] == lastItem[me.idField]),
      //     );

      //     if (
      //       column.columnType === me.$ms.constant.ColumnType.Combobox ||
      //       column.columnType === me.$ms.constant.ColumnType.Enum
      //     ) {
      //       // Biến check xem metaData lấy từ xổ combo hay lấy từ dòng dữ liệu
      //       let isShowCombo = true;

      //       let metaData = editor.getMetaData();
      //       //Th chưa chọn gì combo
      //       if (JSON.stringify(metaData) === '{}') {
      //         metaData = me.dataView[rowIndex];
      //         isShowCombo = false;
      //       }

      //     if (lastIndexView !== -1) {
      //       //Emit ra ngoài các form tự xử lý trường hợp là combo
      //       // cập nhật dữ liệu vào các trường thông tin liên quan (vd dataField của cột là budgetSourceCode thì cần cập nhật thêm name, id, ...)
      //       this.$emit(
      //         'copyActionClick',
      //         actionId,
      //         objAssign,
      //         metaData,
      //         column,
      //         me,
      //         lastIndexView,
      //         rowIndex,
      //         isShowCombo,
      //         me.updateRowBusiness.bind(me),
      //       );
      //     }
      //   } else {
      //     let metaData = me.dataView[rowIndex];
      //     if (lastIndexView !== -1) {
      //       // cập nhật dữ liệu vào các trường thông tin liên quan (vd dataField của cột là budgetSourceCode thì cần cập nhật thêm name, id, ...)
      //       this.$emit(
      //         'copyActionClick',
      //         actionId,
      //         objAssign,
      //         metaData,
      //         column,
      //         me,
      //         lastIndexView,
      //         rowIndex,
      //         false,
      //         me.updateRowBusiness.bind(me),
      //       );
      //     }
      //   }
      //   if (objAssign) {
      //     if (lastIndexView !== -1) {
      //       let startIndex = rowIndex + 1;
      //       let endIndex = lastIndexView;
      //       if (actionId == this.$ms.constant.EditorAction.CopyUpRow) {
      //         startIndex = 0;
      //         endIndex = rowIndex - 1;
      //       }
      //       // cập nhật dữ liệu vào các dòng (tại dataField của cột)
      //       for (let index = startIndex; index <= endIndex; index++) {
      //         const element = me.dataView[index];
      //         for (const key in objAssign) {
      //           if (Object.hasOwnProperty.call(objAssign, key)) {
      //             const val = objAssign[key];
      //             element[key] = val;
      //           }
      //         }
      //         commonFn.changeStateRow(element);
      //       }
      //     }
      //   }
      //   //Thực hiện validate lại cả grid
      //   me.validate();
      // }
      // return;
    },

    /**
     * reset validate của grid
     * NCPHUOC 21/04/2022
     */
    resetValidate() {
      const me = this;
      const colHasRules = me.columnx
        .map((item, index) => {
          if (item.rules && item.rules.length > 0) {
            return index;
          }
          return -1;
        })
        .filter(x => x !== -1);
      if (colHasRules.some(x => x >= 0)) {
        //Duyệt dòng cột
        colHasRules.forEach(colIndex => {
          this.dataView.forEach((row, rowIndex) => {
            //Lấy ra editor của cell
            const editor = me.getCellEditor(colIndex, rowIndex);
            if (editor && typeof editor.clearValidate === 'function') {
              editor.clearValidate();
            }
          });
        });
      }
    },
    /**
     * Hàm này chỉ validate lại những control mà đã validate lỗi trước đó
     * Created by NNKIEM 20/06/2023
     */
    reloadValidate() {
      const me = this;
      const colHasRules = me.columnx
        .map((item, index) => {
          if (item.rules && item.rules.length > 0) {
            return index;
          }
          return -1;
        })
        .filter(x => x !== -1);
      if (colHasRules.some(x => x >= 0)) {
        //Duyệt dòng cột
        colHasRules.forEach(colIndex => {
          this.dataView.forEach((row, rowIndex) => {
            //Lấy ra editor của cell
            const editor = me.getCellEditor(colIndex, rowIndex);
            if (editor && editor.errorMessage && typeof editor.validate === 'function') {
              editor.validate();
            }
          });
        });
      }
    },

    /**
     * @index có thể < 0, hoạc lớn hơn pagesize
     * nqhuy1 19/4/2024
     */
    getRowByViewIndex(viewIndex) {
      if (this.pagination) {
        const startIndex = this.getPageSize() * (this.currentPage - 1);
        return this.dataViewAllPagin[startIndex + viewIndex] ?? null;
      }
      return this.dataView[viewIndex] ?? null;
    },

    /**
     * reset tất cả validate của grid
     * NCPHUOC 21/04/2022
     */
    resetAllValidate() {
      const me = this;
      //Duyệt dòng cột
      me.columnx.forEach((col, colIndex) => {
        this.dataView.forEach((row, rowIndex) => {
          //Lấy ra editor của cell
          const editor = me.getCellEditor(colIndex, rowIndex);
          if (editor && typeof editor.clearValidate === 'function') {
            editor.clearValidate();
          }
        });
      });
    },

    addBusinessValidate(businessErrors) {
      if (Array.isArray(businessErrors) && businessErrors.length > 0) {
        businessErrors.forEach(({colIndex, rowIndex, errorMessage}) => {
          if (Number.isInteger(colIndex) && Number.isInteger(rowIndex) && errorMessage) {
            const cell = this.getCellEditor(colIndex, rowIndex);
            if (cell) {
              cell.errorMessage = errorMessage;
            }
          }
        });
      }
    },
    /**
     * Thay đổi lock của column
     */
    columnChangeLock(col, locked) {
      const me = this;

      if (locked) {
        for (let i = 0; i < me.columnx.length; i++) {
          let column = me.columnx[i];
          column['lock'] = true;

          if (col === column) {
            break;
          }
        }
      } else {
        for (let i = me.columnx.length - 1; i >= 0; i--) {
          let column = me.columnx[i];
          column['lock'] = false;
          if (col === column) {
            break;
          }
        }
      }

      me.updateStickyOffset();
    },

    /**
     * scroll table
     * HTHIEP 28.03.2022: Sửa lỗi không có footer thì bỏ qua
     */
    tableScroll(e) {
      // Kiểm tra xem có combo hay không để ẩn khi lăn chuột
      if (
        this._currentEditor &&
        this._currentEditor.$refs &&
        this._currentEditor.$refs['msCombobox'] &&
        this._currentEditor.$refs['msCombobox'].expanded
      ) {
        this._currentEditor.$refs['msCombobox'].expanded = false;
      }
      // Kiểm tra nếu có footer thì mới xử lý
      if (!this.footer) {
        return;
      }
      const me = this,
        tableFooter = me.$refs.tableFooter;
      if (!tableFooter) {
        return;
      }
      tableFooter.scrollLeft = e.target?.scrollLeft;
    },
    rowClick(dataRow, indexRow) {
      const me = this;
      me.$emit('msRowClick', dataRow, indexRow);
    },
    /**
     * Lấy dữ liệu data grid view
     * HTHIEP 08.07.2022
     */
    getData() {
      return this.dataView;
    },
    /**
     * Chuyển về trang chỉ định
     */
    setPage(page) {
      this.currentPage = page;
    },
    /**
     * Show mask
     * HTHIEP 11.07.2022
     */
    showMask() {
      this.loading = true;
    },
    /**
     * Xóa mask
     */
    unMask() {
      this.loading = false;
    },
    /**
     * Lấy ra columns
     * NCPHUOC 19/07/2022
     */
    getColumns() {
      return this.columnx;
    },
    /**
     * Start edit 1 row (hàm call từ ngoài vào grid) đáp ứng các nghiệp vụ muốn mở cell lên khi validate lỗi
     * NCPHUOC 27/03/2023
     */
    startEditCell(colIndex, rowIndex) {
      if (Number.isInteger(colIndex) && Number.isInteger(colIndex) && colIndex >= 0 && rowIndex >= 0) {
        const cellInstance = this.getCellEditor(colIndex, rowIndex);
        if (cellInstance && cellInstance.$el) {
          cellInstance.$el.click();
        }
      }
    },

    // setHeightThOnFirefox() {
    checkIsFirefox() {
      const isFirefox = /firefox/i.test(navigator.userAgent);
      return isFirefox;
    },
  },
  beforeUnmount() {
    const me = this;
    window.removeEventListener('resize', me.windowResize);
  },
});
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/MsGridViewer.scss';
th.ms-th {
  &.ms-col-th,
  &.multiple-cell {
    height: $ms-th-grid-height;
    //border-right: 1px solid $ms-th-grid-border-color;
  }
  &.multiple-cell-firefox {
    height: auto;
  }
}
:deep(.ms-th.widget-title) {
  right: 0;
  z-index: 3;
  border-left: none !important;
  border-right: none !important;
}
.input-invisiabled {
  background: rgba(255, 255, 255, 0);
  overflow: hidden;
  position: fixed;
  width: 1px;
  height: 1px;
  z-index: -1;
  opacity: 0;
}
.table-footer {
  z-index: 1;
  // bottom: -2px !important;
  border-bottom: 1px solid $secondary;
}
.ms-th.drag-data {
  width: 56px;
  padding: 0;
}
:deep(div.ms-editor) {
  margin: 0;
}
:deep(.lb-total-amount) {
  float: right;
  margin-top: 10px;
  label {
    padding: 0 0 0 35px;
    font-weight: bold;
  }
}

:deep(.edit-disabled) {
  a.editor-click {
    pointer-events: none;
  }
}

.empty-tr {
  td {
    overflow: visible;
  }
  .empty-addnew {
    line-height: 28px;
    cursor: pointer;
    background: white;
    white-space: nowrap;
  }
}

.ms-editor {
  display: block;
  th.tax_rate {
    :deep(.ms-th-title) {
      p {
        text-align: right;
      }
    }
  }
  :deep(.ms-th-title) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    align-items: center;
  }
}

.ms-footer {
  th {
    background: $white;
    &.drag-row-footer {
      height: 30px;
      width: 30px;
      min-width: 30px;
    }
    &:first-child {
      span {
        white-space: nowrap;
      }
    }
  }
}

tfoot {
  .footer-total-count {
    font-weight: 400;
  }
}
.table-paging {
  position: sticky;
  bottom: 0;
  width: 100%;
  left: 0;
  z-index: 2;
  // border-top: 1px solid $ms-th-grid-border-color;
}
.has-scroll-y {
  .table-paging {
    padding-right: 0;
    padding-left: 0;
  }
}
.ms-th-editor {
  &.row-group {
    &.heightoptionvalue1 {
      height: 24px !important;
    }
    &.heightoptionvalue2 {
      height: 24px !important;
    }
  }
}
:deep(td.sticky) {
  overflow: unset;
}
</style>

<style lang="scss">
.option-menu.v-popper__popper {
  z-index: 1100 !important;
  top: -3px !important;
  .v-popper__inner {
    border: solid 1px $secondary;
    border-radius: 4px;
    box-shadow: $box-box-shadow;
  }
  .v-popper__arrow-container {
    display: none;
  }
  .menu-wrapper-item {
    padding: 0 10px !important;
    height: 28px;
    line-height: 28px;
  }
}

.ms-td .ms-td-normal-span-unlimited-line span {
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
}

.ms-td .ms-td-normal-span span {
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
}
.ms-td .ms-td-normal-span-two-line span {
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
}

.ms-right-click-menu {
  #right-click-menu {
    position: fixed;
    outline: none;
  }
}

.heightoptionvalueMenuWrapper1 {
  font-size: $font-size-custom-small !important;
}
.heightoptionvalueMenuWrapper2 {
  font-size: $font-size-custom-big !important;
}

.heightoptionvalue-wrapper1 {
  height: $input-height-custom-small-no-border;
  font-size: $font-size-custom-small !important;
  line-height: $input-height-custom-small-no-border !important;
}

.heightoptionvalue-wrapper2 {
  height: $input-height-custom-big-no-border;
  font-size: $font-size-custom-big !important;
  line-height: $input-height-custom-big-no-border !important;
}

.footer-sum-gr {
  font-size: 13px;
}
</style>
